// **********************************************
// Localization file for game: framework dictionary
//
// created on 4/23/2018 5:18:12 PM
// **********************************************
/*exported dictionaryVar*/
export var dictionaryVar = dictionaryVar || {};
dictionaryVar["nl-nl"] = dictionaryVar["nl-nl"] || {};
dictionaryVar["nl-nl"]["loadingScreenLoading"] = "Laden...";
dictionaryVar["nl-nl"]["startScreenPlay"] = "SPELEN";
dictionaryVar["nl-nl"]["levelMapScreenTotalScore"] = "Totale score";
dictionaryVar["nl-nl"]["levelEndScreenTitle_level"] = "Level <VALUE>";
dictionaryVar["nl-nl"]["levelEndScreenTitle_difficulty"] = "Goed Gedaan!";
dictionaryVar["nl-nl"]["levelEndScreenTitle_endless"] = "Level <VALUE>";
dictionaryVar["nl-nl"]["levelEndScreenTotalScore"] = "Totale score";
dictionaryVar["nl-nl"]["levelEndScreenSubTitle_levelFailed"] = "Level niet gehaald";
dictionaryVar["nl-nl"]["levelEndScreenTimeLeft"] = "Tijd over";
dictionaryVar["nl-nl"]["levelEndScreenTimeBonus"] = "Tijdbonus";
dictionaryVar["nl-nl"]["levelEndScreenHighScore"] = "High score";
dictionaryVar["nl-nl"]["optionsStartScreen"] = "Hoofdmenu";
dictionaryVar["nl-nl"]["optionsQuit"] = "Stop";
dictionaryVar["nl-nl"]["optionsResume"] = "Terug naar spel";
dictionaryVar["nl-nl"]["optionsTutorial"] = "Speluitleg";
dictionaryVar["nl-nl"]["optionsHighScore"] = "High scores";
dictionaryVar["nl-nl"]["optionsMoreGames"] = "Meer Spellen";
dictionaryVar["nl-nl"]["optionsDifficulty_easy"] = "Makkelijk";
dictionaryVar["nl-nl"]["optionsDifficulty_medium"] = "Gemiddeld";
dictionaryVar["nl-nl"]["optionsDifficulty_hard"] = "Moeilijk";
dictionaryVar["nl-nl"]["optionsMusic_on"] = "Aan";
dictionaryVar["nl-nl"]["optionsMusic_off"] = "Uit";
dictionaryVar["nl-nl"]["optionsSFX_on"] = "Aan";
dictionaryVar["nl-nl"]["optionsSFX_off"] = "Uit";
dictionaryVar["nl-nl"]["optionsLang_en-us"] = "Engels (US)";
dictionaryVar["nl-nl"]["optionsLang_en-gb"] = "Engels (GB)";
dictionaryVar["nl-nl"]["optionsLang_nl-nl"] = "Nederlands";
dictionaryVar["nl-nl"]["gameEndScreenTitle"] = "Gefeliciteerd!\nJe hebt gewonnen.";
dictionaryVar["nl-nl"]["gameEndScreenBtnText"] = "Ga verder";
dictionaryVar["nl-nl"]["optionsTitle"] = "Instellingen";
dictionaryVar["nl-nl"]["optionsQuitConfirmationText"] = "Pas op!\n\nAls je nu stopt verlies je alle voortgang in dit level. Weet je zeker dat je wilt stoppen?";
dictionaryVar["nl-nl"]["optionsQuitConfirmBtn_No"] = "Nee";
dictionaryVar["nl-nl"]["optionsQuitConfirmBtn_Yes"] = "Ja, ik weet het zeker";
dictionaryVar["nl-nl"]["levelMapScreenTitle"] = "Kies een level";
dictionaryVar["nl-nl"]["optionsRestartConfirmationText"] = "Pas op!\n\nAls je nu herstart verlies je alle voortgang in dit level. Weet je zeker dat je wilt herstarten?";
dictionaryVar["nl-nl"]["optionsRestart"] = "Herstart";
dictionaryVar["nl-nl"]["optionsSFXBig_on"] = "Geluid aan";
dictionaryVar["nl-nl"]["optionsSFXBig_off"] = "Geluid uit";
dictionaryVar["nl-nl"]["optionsAbout_title"] = "Over ons";
dictionaryVar["nl-nl"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\nCopyright © 2017";
dictionaryVar["nl-nl"]["optionsAbout_backBtn"] = "Terug";
dictionaryVar["nl-nl"]["optionsAbout_version"] = "versie:";
dictionaryVar["nl-nl"]["optionsAbout"] = "Over ons";
dictionaryVar["nl-nl"]["levelEndScreenMedal"] = "VERBETERD!";
dictionaryVar["nl-nl"]["startScreenQuestionaire"] = "Wat vind jij?";
dictionaryVar["nl-nl"]["levelMapScreenWorld_0"] = "Kies een level";
dictionaryVar["nl-nl"]["startScreenByTinglyGames"] = "door: CoolGames";
dictionaryVar["nl-nl"]["optionsLang_de-de"] = "Duits";
dictionaryVar["nl-nl"]["optionsLang_tr-tr"] = "Turks";
dictionaryVar["nl-nl"]["optionsAbout_header"] = "Ontwikkeld door:";
dictionaryVar["nl-nl"]["levelEndScreenViewHighscoreBtn"] = "Scores bekijken";
dictionaryVar["nl-nl"]["levelEndScreenSubmitHighscoreBtn"] = "Score verzenden";
dictionaryVar["nl-nl"]["challengeStartScreenTitle_challengee_friend"] = "Je bent uitgedaagd door:";
dictionaryVar["nl-nl"]["challengeStartTextScore"] = "Punten van <NAME>:";
dictionaryVar["nl-nl"]["challengeStartTextTime"] = "Tijd van <NAME>:";
dictionaryVar["nl-nl"]["challengeStartScreenToWin"] = "Te winnen aantal Fairplay munten:";
dictionaryVar["nl-nl"]["challengeEndScreenWinnings"] = "Je hebt <AMOUNT> Fairplay munten gewonnen!";
dictionaryVar["nl-nl"]["challengeEndScreenOutcomeMessage_WON"] = "Je hebt de uitdaging gewonnen!";
dictionaryVar["nl-nl"]["challengeEndScreenOutcomeMessage_LOST"] = "Je hebt de uitdaging verloren.";
dictionaryVar["nl-nl"]["challengeEndScreenOutcomeMessage_TIED"] = "Jullie hebben gelijk gespeeld.";
dictionaryVar["nl-nl"]["challengeCancelConfirmText"] = "Je staat op het punt de uitdaging te annuleren. Je inzet wordt teruggestort minus de uitdagingskosten. Weet je zeker dat je de uitdaging wilt annuleren? ";
dictionaryVar["nl-nl"]["challengeCancelConfirmBtn_yes"] = "Ja";
dictionaryVar["nl-nl"]["challengeCancelConfirmBtn_no"] = "Nee";
dictionaryVar["nl-nl"]["challengeEndScreensBtn_submit"] = "Verstuur uitdaging";
dictionaryVar["nl-nl"]["challengeEndScreenBtn_cancel"] = "Annuleer uitdaging";
dictionaryVar["nl-nl"]["challengeEndScreenName_you"] = "Jij";
dictionaryVar["nl-nl"]["challengeEndScreenChallengeSend_error"] = "Er is een fout opgetreden bij het versturen van de uitdaging. Probeer het later nog een keer.";
dictionaryVar["nl-nl"]["challengeEndScreenChallengeSend_success"] = "Je uitdaging is verstuurd!";
dictionaryVar["nl-nl"]["challengeCancelMessage_error"] = "Er is een fout opgetreden bij het annuleren van de uitdaging. Probeer het later nog een keer.";
dictionaryVar["nl-nl"]["challengeCancelMessage_success"] = "De uitdaging is geannuleerd.";
dictionaryVar["nl-nl"]["challengeEndScreenScoreSend_error"] = "Er is een fout opgetreden tijdens de communicatie met de server. Probeer het later nog een keer.";
dictionaryVar["nl-nl"]["challengeStartScreenTitle_challengee_stranger"] = "Jouw tegenstander:";
dictionaryVar["nl-nl"]["challengeStartScreenTitle_challenger_friend"] = "Jouw tegenstander:";
dictionaryVar["nl-nl"]["challengeStartScreenTitle_challenger_stranger"] = "Je zet een uitdaging voor:";
dictionaryVar["nl-nl"]["challengeStartTextTime_challenger"] = "Speel het spel en zet een tijd neer.";
dictionaryVar["nl-nl"]["challengeStartTextScore_challenger"] = "Speel het spel en zet een score neer.";
dictionaryVar["nl-nl"]["challengeForfeitConfirmText"] = "Je staat op het punt de uitdaging op te geven. Weet je zeker dat je dit wilt doen?";
dictionaryVar["nl-nl"]["challengeForfeitConfirmBtn_yes"] = "Ja";
dictionaryVar["nl-nl"]["challengeForfeitConfirmBtn_no"] = "Nee";
dictionaryVar["nl-nl"]["challengeForfeitMessage_success"] = "Je hebt de uitdaging opgegeven.";
dictionaryVar["nl-nl"]["challengeForfeitMessage_error"] = "Er is een fout opgetreden tijdens het opgeven van de uitdaging. Probeer het later nog een keer.";
dictionaryVar["nl-nl"]["optionsChallengeForfeit"] = "Geef op";
dictionaryVar["nl-nl"]["optionsChallengeCancel"] = "Stop";
dictionaryVar["nl-nl"]["challengeLoadingError_notValid"] = "Sorry, deze uitdaging kan niet meer gespeeld worden.";
dictionaryVar["nl-nl"]["challengeLoadingError_notStarted"] = "Kan de server niet bereiken. Probeer het later nog een keer.";
dictionaryVar["nl-nl"]["levelEndScreenHighScore_time"] = "Beste tijd:";
dictionaryVar["nl-nl"]["levelEndScreenTotalScore_time"] = "Totale tijd:";
dictionaryVar["nl-nl"]["optionsLang_fr-fr"] = "Frans";
dictionaryVar["nl-nl"]["optionsLang_ko-kr"] = "Koreaans";
dictionaryVar["nl-nl"]["optionsLang_ar-eg"] = "Arabisch";
dictionaryVar["nl-nl"]["optionsLang_es-es"] = "Spaans";
dictionaryVar["nl-nl"]["optionsLang_pt-br"] = "Braziliaans-Portugees";
dictionaryVar["nl-nl"]["optionsLang_ru-ru"] = "Russisch";
dictionaryVar["nl-nl"]["optionsExit"] = "Stoppen";
dictionaryVar["nl-nl"]["levelEndScreenTotalScore_number"] = "Totale score:";
dictionaryVar["nl-nl"]["levelEndScreenHighScore_number"] = "Topscore:";
dictionaryVar["nl-nl"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> heeft 72 uur om de uitdaging aan te nemen of te weigeren. Als <NAME> je uitdaging weigert of niet accepteert binnen 72 uur worden je inzet en uitdagingskosten teruggestort.";
dictionaryVar["nl-nl"]["challengeEndScreenChallengeSend_submessage_stranger"] = "Als niemand binnen 72 uur je uitdaging accepteert, worden je inzet en uitdagingskosten teruggestort.";
dictionaryVar["nl-nl"]["challengeForfeitMessage_winnings"] = "<NAME> heeft <AMOUNT> Fairplay munten gewonnen!";
dictionaryVar["nl-nl"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["nl-nl"]["optionsLang_jp-jp"] = "Japans";
dictionaryVar["nl-nl"]["optionsLang_it-it"] = "Italiaans";
dictionaryVar["en-us"] = dictionaryVar["en-us"] || {};
dictionaryVar["en-us"]["loadingScreenLoading"] = "Loading...";
dictionaryVar["en-us"]["startScreenPlay"] = "PLAY";
dictionaryVar["en-us"]["levelMapScreenTotalScore"] = "Total score";
dictionaryVar["en-us"]["levelEndScreenTitle_level"] = "Level <VALUE>";
dictionaryVar["en-us"]["levelEndScreenTitle_difficulty"] = "Well done!";
dictionaryVar["en-us"]["levelEndScreenTitle_endless"] = "Stage <VALUE>";
dictionaryVar["en-us"]["levelEndScreenTotalScore"] = "Total score";
dictionaryVar["en-us"]["levelEndScreenSubTitle_levelFailed"] = "Level failed";
dictionaryVar["en-us"]["levelEndScreenTimeLeft"] = "Time remaining";
dictionaryVar["en-us"]["levelEndScreenTimeBonus"] = "Time bonus";
dictionaryVar["en-us"]["levelEndScreenHighScore"] = "High score";
dictionaryVar["en-us"]["optionsStartScreen"] = "Main menu";
dictionaryVar["en-us"]["optionsQuit"] = "Quit";
dictionaryVar["en-us"]["optionsResume"] = "Resume";
dictionaryVar["en-us"]["optionsTutorial"] = "How to play";
dictionaryVar["en-us"]["optionsHighScore"] = "High scores";
dictionaryVar["en-us"]["optionsMoreGames"] = "More Games";
dictionaryVar["en-us"]["optionsDifficulty_easy"] = "Easy";
dictionaryVar["en-us"]["optionsDifficulty_medium"] = "Medium";
dictionaryVar["en-us"]["optionsDifficulty_hard"] = "Difficult";
dictionaryVar["en-us"]["optionsMusic_on"] = "On";
dictionaryVar["en-us"]["optionsMusic_off"] = "Off";
dictionaryVar["en-us"]["optionsSFX_on"] = "On";
dictionaryVar["en-us"]["optionsSFX_off"] = "Off";
dictionaryVar["en-us"]["optionsLang_en-us"] = "English (US)";
dictionaryVar["en-us"]["optionsLang_en-gb"] = "English (GB)";
dictionaryVar["en-us"]["optionsLang_nl-nl"] = "Dutch";
dictionaryVar["en-us"]["gameEndScreenTitle"] = "Congratulations!\nYou have completed the game.";
dictionaryVar["en-us"]["gameEndScreenBtnText"] = "Continue";
dictionaryVar["en-us"]["optionsTitle"] = "Settings";
dictionaryVar["en-us"]["optionsQuitConfirmationText"] = "Attention!\n\nIf you quit now you will lose all progress made during this level. Are you sure you want to quit?";
dictionaryVar["en-us"]["optionsQuitConfirmBtn_No"] = "No";
dictionaryVar["en-us"]["optionsQuitConfirmBtn_Yes"] = "Yes, I'm sure";
dictionaryVar["en-us"]["levelMapScreenTitle"] = "Select a level";
dictionaryVar["en-us"]["optionsRestartConfirmationText"] = "Attention!\n\nIf you restart now you will lose all progress made during this level. Are you sure you want to restart?";
dictionaryVar["en-us"]["optionsRestart"] = "Restart";
dictionaryVar["en-us"]["optionsSFXBig_on"] = "Sound on";
dictionaryVar["en-us"]["optionsSFXBig_off"] = "Sound off";
dictionaryVar["en-us"]["optionsAbout_title"] = "About";
dictionaryVar["en-us"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["en-us"]["optionsAbout_backBtn"] = "Back";
dictionaryVar["en-us"]["optionsAbout_version"] = "version:";
dictionaryVar["en-us"]["optionsAbout"] = "About";
dictionaryVar["en-us"]["levelEndScreenMedal"] = "IMPROVED!";
dictionaryVar["en-us"]["startScreenQuestionaire"] = "What do you think?";
dictionaryVar["en-us"]["levelMapScreenWorld_0"] = "Select a level";
dictionaryVar["en-us"]["startScreenByTinglyGames"] = "by: CoolGames";
dictionaryVar["en-us"]["optionsLang_de-de"] = "German";
dictionaryVar["en-us"]["optionsLang_tr-tr"] = "Turkish";
dictionaryVar["en-us"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["en-us"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["en-us"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["en-us"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["en-us"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["en-us"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["en-us"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["en-us"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["en-us"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["en-us"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["en-us"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["en-us"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["en-us"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["en-us"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["en-us"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["en-us"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["en-us"]["challengeEndScreenName_you"] = "You";
dictionaryVar["en-us"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["en-us"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["en-us"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["en-us"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["en-us"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["en-us"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["en-us"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["en-us"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["en-us"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["en-us"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["en-us"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["en-us"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["en-us"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["en-us"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["en-us"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["en-us"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["en-us"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["en-us"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["en-us"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["en-us"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["en-us"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["en-us"]["optionsLang_fr-fr"] = "French";
dictionaryVar["en-us"]["optionsLang_ko-kr"] = "Korean";
dictionaryVar["en-us"]["optionsLang_ar-eg"] = "Arabic";
dictionaryVar["en-us"]["optionsLang_es-es"] = "Spanish";
dictionaryVar["en-us"]["optionsLang_pt-br"] = "Brazilian-Portuguese";
dictionaryVar["en-us"]["optionsLang_ru-ru"] = "Russian";
dictionaryVar["en-us"]["optionsExit"] = "Exit";
dictionaryVar["en-us"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["en-us"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["en-us"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["en-us"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["en-us"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["en-us"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["en-us"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["en-us"]["optionsLang_it-it"] = "Italian";
dictionaryVar["en-gb"] = dictionaryVar["en-gb"] || {};
dictionaryVar["en-gb"]["loadingScreenLoading"] = "Loading...";
dictionaryVar["en-gb"]["startScreenPlay"] = "PLAY";
dictionaryVar["en-gb"]["levelMapScreenTotalScore"] = "Total score";
dictionaryVar["en-gb"]["levelEndScreenTitle_level"] = "Level <VALUE>";
dictionaryVar["en-gb"]["levelEndScreenTitle_difficulty"] = "Well done!";
dictionaryVar["en-gb"]["levelEndScreenTitle_endless"] = "Stage <VALUE>";
dictionaryVar["en-gb"]["levelEndScreenTotalScore"] = "Total score";
dictionaryVar["en-gb"]["levelEndScreenSubTitle_levelFailed"] = "Level failed";
dictionaryVar["en-gb"]["levelEndScreenTimeLeft"] = "Time remaining";
dictionaryVar["en-gb"]["levelEndScreenTimeBonus"] = "Time bonus";
dictionaryVar["en-gb"]["levelEndScreenHighScore"] = "High score";
dictionaryVar["en-gb"]["optionsStartScreen"] = "Main menu";
dictionaryVar["en-gb"]["optionsQuit"] = "Quit";
dictionaryVar["en-gb"]["optionsResume"] = "Resume";
dictionaryVar["en-gb"]["optionsTutorial"] = "How to play";
dictionaryVar["en-gb"]["optionsHighScore"] = "High scores";
dictionaryVar["en-gb"]["optionsMoreGames"] = "More Games";
dictionaryVar["en-gb"]["optionsDifficulty_easy"] = "Easy";
dictionaryVar["en-gb"]["optionsDifficulty_medium"] = "Medium";
dictionaryVar["en-gb"]["optionsDifficulty_hard"] = "Difficult";
dictionaryVar["en-gb"]["optionsMusic_on"] = "On";
dictionaryVar["en-gb"]["optionsMusic_off"] = "Off";
dictionaryVar["en-gb"]["optionsSFX_on"] = "On";
dictionaryVar["en-gb"]["optionsSFX_off"] = "Off";
dictionaryVar["en-gb"]["optionsLang_en-us"] = "English (US)";
dictionaryVar["en-gb"]["optionsLang_en-gb"] = "English (GB)";
dictionaryVar["en-gb"]["optionsLang_nl-nl"] = "Dutch";
dictionaryVar["en-gb"]["gameEndScreenTitle"] = "Congratulations!\nYou have completed the game.";
dictionaryVar["en-gb"]["gameEndScreenBtnText"] = "Continue";
dictionaryVar["en-gb"]["optionsTitle"] = "Settings";
dictionaryVar["en-gb"]["optionsQuitConfirmationText"] = "Attention!\n\nIf you quit now you will lose all progress made during this level. Are you sure you want to quit?";
dictionaryVar["en-gb"]["optionsQuitConfirmBtn_No"] = "No";
dictionaryVar["en-gb"]["optionsQuitConfirmBtn_Yes"] = "Yes, I'm sure";
dictionaryVar["en-gb"]["levelMapScreenTitle"] = "Select a level";
dictionaryVar["en-gb"]["optionsRestartConfirmationText"] = "Attention!\n\nIf you restart now you will lose all progress made during this level. Are you sure you want to restart?";
dictionaryVar["en-gb"]["optionsRestart"] = "Restart";
dictionaryVar["en-gb"]["optionsSFXBig_on"] = "Sound on";
dictionaryVar["en-gb"]["optionsSFXBig_off"] = "Sound off";
dictionaryVar["en-gb"]["optionsAbout_title"] = "About";
dictionaryVar["en-gb"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["en-gb"]["optionsAbout_backBtn"] = "Back";
dictionaryVar["en-gb"]["optionsAbout_version"] = "version:";
dictionaryVar["en-gb"]["optionsAbout"] = "About";
dictionaryVar["en-gb"]["levelEndScreenMedal"] = "IMPROVED!";
dictionaryVar["en-gb"]["startScreenQuestionaire"] = "What do you think?";
dictionaryVar["en-gb"]["levelMapScreenWorld_0"] = "Select a level";
dictionaryVar["en-gb"]["startScreenByTinglyGames"] = "by: CoolGames";
dictionaryVar["en-gb"]["optionsLang_de-de"] = "German";
dictionaryVar["en-gb"]["optionsLang_tr-tr"] = "Turkish";
dictionaryVar["en-gb"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["en-gb"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["en-gb"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["en-gb"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["en-gb"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["en-gb"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["en-gb"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["en-gb"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["en-gb"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["en-gb"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["en-gb"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["en-gb"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["en-gb"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["en-gb"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["en-gb"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["en-gb"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["en-gb"]["challengeEndScreenName_you"] = "You";
dictionaryVar["en-gb"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["en-gb"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["en-gb"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["en-gb"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["en-gb"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["en-gb"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["en-gb"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["en-gb"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["en-gb"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["en-gb"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["en-gb"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you wish to proceed?";
dictionaryVar["en-gb"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["en-gb"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["en-gb"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["en-gb"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["en-gb"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["en-gb"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["en-gb"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["en-gb"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["en-gb"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["en-gb"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["en-gb"]["optionsLang_fr-fr"] = "French";
dictionaryVar["en-gb"]["optionsLang_ko-kr"] = "Korean";
dictionaryVar["en-gb"]["optionsLang_ar-eg"] = "Arabic";
dictionaryVar["en-gb"]["optionsLang_es-es"] = "Spanish";
dictionaryVar["en-gb"]["optionsLang_pt-br"] = "Brazilian-Portuguese";
dictionaryVar["en-gb"]["optionsLang_ru-ru"] = "Russian";
dictionaryVar["en-gb"]["optionsExit"] = "Exit";
dictionaryVar["en-gb"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["en-gb"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["en-gb"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["en-gb"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["en-gb"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["en-gb"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["en-gb"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["en-gb"]["optionsLang_it-it"] = "Italian";
dictionaryVar["de-de"] = dictionaryVar["de-de"] || {};
dictionaryVar["de-de"]["loadingScreenLoading"] = "Laden ...";
dictionaryVar["de-de"]["startScreenPlay"] = "SPIELEN";
dictionaryVar["de-de"]["levelMapScreenTotalScore"] = "Gesamtpunkte";
dictionaryVar["de-de"]["levelEndScreenTitle_level"] = "Level <VALUE>";
dictionaryVar["de-de"]["levelEndScreenTitle_difficulty"] = "Sehr gut!";
dictionaryVar["de-de"]["levelEndScreenTitle_endless"] = "Stufe <VALUE>";
dictionaryVar["de-de"]["levelEndScreenTotalScore"] = "Gesamtpunkte";
dictionaryVar["de-de"]["levelEndScreenSubTitle_levelFailed"] = "Level nicht geschafft";
dictionaryVar["de-de"]["levelEndScreenTimeLeft"] = "Restzeit";
dictionaryVar["de-de"]["levelEndScreenTimeBonus"] = "Zeitbonus";
dictionaryVar["de-de"]["levelEndScreenHighScore"] = "Highscore";
dictionaryVar["de-de"]["optionsStartScreen"] = "Hauptmenü";
dictionaryVar["de-de"]["optionsQuit"] = "Beenden";
dictionaryVar["de-de"]["optionsResume"] = "Weiterspielen";
dictionaryVar["de-de"]["optionsTutorial"] = "So wird gespielt";
dictionaryVar["de-de"]["optionsHighScore"] = "Highscores";
dictionaryVar["de-de"]["optionsMoreGames"] = "Weitere Spiele";
dictionaryVar["de-de"]["optionsDifficulty_easy"] = "Einfach";
dictionaryVar["de-de"]["optionsDifficulty_medium"] = "Mittel";
dictionaryVar["de-de"]["optionsDifficulty_hard"] = "Schwer";
dictionaryVar["de-de"]["optionsMusic_on"] = "EIN";
dictionaryVar["de-de"]["optionsMusic_off"] = "AUS";
dictionaryVar["de-de"]["optionsSFX_on"] = "EIN";
dictionaryVar["de-de"]["optionsSFX_off"] = "AUS";
dictionaryVar["de-de"]["optionsLang_en-us"] = "Englisch (US)";
dictionaryVar["de-de"]["optionsLang_en-gb"] = "Englisch (GB)";
dictionaryVar["de-de"]["optionsLang_nl-nl"] = "Holländisch";
dictionaryVar["de-de"]["gameEndScreenTitle"] = "Glückwunsch!\nDu hast das Spiel abgeschlossen.";
dictionaryVar["de-de"]["gameEndScreenBtnText"] = "Weiter";
dictionaryVar["de-de"]["optionsTitle"] = "Einstellungen";
dictionaryVar["de-de"]["optionsQuitConfirmationText"] = "Achtung!\n\nWenn du jetzt aufhörst, verlierst du alle in diesem Level gemachten Fortschritte. Willst du wirklich aufhören?";
dictionaryVar["de-de"]["optionsQuitConfirmBtn_No"] = "NEIN";
dictionaryVar["de-de"]["optionsQuitConfirmBtn_Yes"] = "Ja, ich bin mir sicher";
dictionaryVar["de-de"]["levelMapScreenTitle"] = "Wähle ein Level";
dictionaryVar["de-de"]["optionsRestartConfirmationText"] = "Achtung!\n\nWenn du jetzt neu startest, verlierst du alle in diesem Level gemachten Fortschritte. Willst du wirklich neu starten?";
dictionaryVar["de-de"]["optionsRestart"] = "Neustart";
dictionaryVar["de-de"]["optionsSFXBig_on"] = "Sound EIN";
dictionaryVar["de-de"]["optionsSFXBig_off"] = "Sound AUS";
dictionaryVar["de-de"]["optionsAbout_title"] = "Über";
dictionaryVar["de-de"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["de-de"]["optionsAbout_backBtn"] = "Zurück";
dictionaryVar["de-de"]["optionsAbout_version"] = "Version:";
dictionaryVar["de-de"]["optionsAbout"] = "Über";
dictionaryVar["de-de"]["levelEndScreenMedal"] = "VERBESSERT!";
dictionaryVar["de-de"]["startScreenQuestionaire"] = "Deine Meinung zählt!";
dictionaryVar["de-de"]["levelMapScreenWorld_0"] = "Wähle ein Level";
dictionaryVar["de-de"]["startScreenByTinglyGames"] = "von: CoolGames";
dictionaryVar["de-de"]["optionsLang_de-de"] = "Deutsch";
dictionaryVar["de-de"]["optionsLang_tr-tr"] = "Türkisch";
dictionaryVar["de-de"]["optionsAbout_header"] = "Entwickelt von:";
dictionaryVar["de-de"]["levelEndScreenViewHighscoreBtn"] = "Punktzahlen ansehen";
dictionaryVar["de-de"]["levelEndScreenSubmitHighscoreBtn"] = "Punktzahl senden";
dictionaryVar["de-de"]["challengeStartScreenTitle_challengee_friend"] = "Dein Gegner:";
dictionaryVar["de-de"]["challengeStartTextScore"] = "Punktzahl von <NAME>:";
dictionaryVar["de-de"]["challengeStartTextTime"] = "Zeit von <NAME>:";
dictionaryVar["de-de"]["challengeStartScreenToWin"] = "Einsatz:";
dictionaryVar["de-de"]["challengeEndScreenWinnings"] = "Du hast <AMOUNT> Fairmünzen gewonnen!";
dictionaryVar["de-de"]["challengeEndScreenOutcomeMessage_WON"] = "Du hast die Partie gewonnen!";
dictionaryVar["de-de"]["challengeEndScreenOutcomeMessage_LOST"] = "Leider hat Dein Gegner die Partie gewonnen.";
dictionaryVar["de-de"]["challengeEndScreenOutcomeMessage_TIED"] = "Gleichstand!";
dictionaryVar["de-de"]["challengeCancelConfirmText"] = "Willst Du Deine Wette wirklich zurückziehen? Dein Wetteinsatz wird Dir zurückgegeben minus die Einsatzgebühr.";
dictionaryVar["de-de"]["challengeCancelConfirmBtn_yes"] = "Ja";
dictionaryVar["de-de"]["challengeCancelConfirmBtn_no"] = "Nein";
dictionaryVar["de-de"]["challengeEndScreensBtn_submit"] = "Herausfordern";
dictionaryVar["de-de"]["challengeEndScreenBtn_cancel"] = "Zurückziehen";
dictionaryVar["de-de"]["challengeEndScreenName_you"] = "Du";
dictionaryVar["de-de"]["challengeEndScreenChallengeSend_error"] = "Leider ist ein Fehler aufgetreten. Probiere es bitte nochmal später.";
dictionaryVar["de-de"]["challengeEndScreenChallengeSend_success"] = "Herausforderung verschickt!";
dictionaryVar["de-de"]["challengeCancelMessage_error"] = "Leider ist ein Fehler aufgetreten. Probiere es bitte nochmal später.";
dictionaryVar["de-de"]["challengeCancelMessage_success"] = "Du hast die Wette erfolgreich zurückgezogen.";
dictionaryVar["de-de"]["challengeEndScreenScoreSend_error"] = "Leider ist ein Fehler aufgetreten. Probiere es bitte nochmal später.";
dictionaryVar["de-de"]["challengeStartScreenTitle_challengee_stranger"] = "Dein Gegner wird:";
dictionaryVar["de-de"]["challengeStartScreenTitle_challenger_friend"] = "Du hast den folgenden Spieler herausgefordert:";
dictionaryVar["de-de"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["de-de"]["challengeStartTextTime_challenger"] = "Spiel um die niedrigste Zeit!";
dictionaryVar["de-de"]["challengeStartTextScore_challenger"] = "Spiel um die hochste Punktzahl!";
dictionaryVar["de-de"]["challengeForfeitConfirmText"] = "Willst du Die Partie wirklich aufgeben?";
dictionaryVar["de-de"]["challengeForfeitConfirmBtn_yes"] = "Ja";
dictionaryVar["de-de"]["challengeForfeitConfirmBtn_no"] = "Nein";
dictionaryVar["de-de"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["de-de"]["challengeForfeitMessage_error"] = "Leider ist ein Fehler aufgetreten. Probiere es bitte nochmal später.";
dictionaryVar["de-de"]["optionsChallengeForfeit"] = "Aufgeben";
dictionaryVar["de-de"]["optionsChallengeCancel"] = "Zurückziehen";
dictionaryVar["de-de"]["challengeLoadingError_notValid"] = "Leider ist diese Partie nicht mehr aktuel.";
dictionaryVar["de-de"]["challengeLoadingError_notStarted"] = "Leider ist ein Fehler aufgetreten. Es konnte keiner Verbindung zum Server hergestellt werden. Versuche es bitte nochmal später.";
dictionaryVar["de-de"]["levelEndScreenHighScore_time"] = "Bestzeit:";
dictionaryVar["de-de"]["levelEndScreenTotalScore_time"] = "Gesamtzeit:";
dictionaryVar["de-de"]["optionsLang_fr-fr"] = "Französisch";
dictionaryVar["de-de"]["optionsLang_ko-kr"] = "Koreanisch";
dictionaryVar["de-de"]["optionsLang_ar-eg"] = "Arabisch";
dictionaryVar["de-de"]["optionsLang_es-es"] = "Spanisch";
dictionaryVar["de-de"]["optionsLang_pt-br"] = "Portugiesisch (Brasilien)";
dictionaryVar["de-de"]["optionsLang_ru-ru"] = "Russisch";
dictionaryVar["de-de"]["optionsExit"] = "Verlassen";
dictionaryVar["de-de"]["levelEndScreenTotalScore_number"] = "Gesamtpunktzahl:";
dictionaryVar["de-de"]["levelEndScreenHighScore_number"] = "Highscore:";
dictionaryVar["de-de"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> hat 72 Stunden um die Wette anzunehmen oder abzulehnen. Sollte <NAME> nicht reagieren oder ablehnen werden Dir Dein Wetteinsatz und die Gebühr zurückerstattet.";
dictionaryVar["de-de"]["challengeEndScreenChallengeSend_submessage_stranger"] = "Als niemanden Deine Herausforderung innerhalb von 72 Stunden annimmt, werden Dir Deinen Wetteinsatz Einsatzgebühr zurückerstattet.";
dictionaryVar["de-de"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["de-de"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["de-de"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["de-de"]["optionsLang_it-it"] = "Italian";
dictionaryVar["fr-fr"] = dictionaryVar["fr-fr"] || {};
dictionaryVar["fr-fr"]["loadingScreenLoading"] = "Chargement...";
dictionaryVar["fr-fr"]["startScreenPlay"] = "JOUER";
dictionaryVar["fr-fr"]["levelMapScreenTotalScore"] = "Score total";
dictionaryVar["fr-fr"]["levelEndScreenTitle_level"] = "Niveau <VALUE>";
dictionaryVar["fr-fr"]["levelEndScreenTitle_difficulty"] = "Bien joué !";
dictionaryVar["fr-fr"]["levelEndScreenTitle_endless"] = "Scène <VALUE>";
dictionaryVar["fr-fr"]["levelEndScreenTotalScore"] = "Score total";
dictionaryVar["fr-fr"]["levelEndScreenSubTitle_levelFailed"] = "Échec du niveau";
dictionaryVar["fr-fr"]["levelEndScreenTimeLeft"] = "Temps restant";
dictionaryVar["fr-fr"]["levelEndScreenTimeBonus"] = "Bonus de temps";
dictionaryVar["fr-fr"]["levelEndScreenHighScore"] = "Meilleur score";
dictionaryVar["fr-fr"]["optionsStartScreen"] = "Menu principal";
dictionaryVar["fr-fr"]["optionsQuit"] = "Quitter";
dictionaryVar["fr-fr"]["optionsResume"] = "Reprendre";
dictionaryVar["fr-fr"]["optionsTutorial"] = "Comment jouer";
dictionaryVar["fr-fr"]["optionsHighScore"] = "Meilleurs scores";
dictionaryVar["fr-fr"]["optionsMoreGames"] = "Plus de jeux";
dictionaryVar["fr-fr"]["optionsDifficulty_easy"] = "Facile";
dictionaryVar["fr-fr"]["optionsDifficulty_medium"] = "Moyen";
dictionaryVar["fr-fr"]["optionsDifficulty_hard"] = "Difficile";
dictionaryVar["fr-fr"]["optionsMusic_on"] = "Avec";
dictionaryVar["fr-fr"]["optionsMusic_off"] = "Sans";
dictionaryVar["fr-fr"]["optionsSFX_on"] = "Avec";
dictionaryVar["fr-fr"]["optionsSFX_off"] = "Sans";
dictionaryVar["fr-fr"]["optionsLang_en-us"] = "Anglais (US)";
dictionaryVar["fr-fr"]["optionsLang_en-gb"] = "Anglais (UK)";
dictionaryVar["fr-fr"]["optionsLang_nl-nl"] = "Néerlandais";
dictionaryVar["fr-fr"]["gameEndScreenTitle"] = "Félicitations !\nVous avez terminé le jeu.";
dictionaryVar["fr-fr"]["gameEndScreenBtnText"] = "Continuer";
dictionaryVar["fr-fr"]["optionsTitle"] = "Paramètres";
dictionaryVar["fr-fr"]["optionsQuitConfirmationText"] = "Attention !\n\nEn quittant maintenant, vous perdrez votre progression pour le niveau en cours. Quitter quand même ?";
dictionaryVar["fr-fr"]["optionsQuitConfirmBtn_No"] = "Non";
dictionaryVar["fr-fr"]["optionsQuitConfirmBtn_Yes"] = "Oui";
dictionaryVar["fr-fr"]["levelMapScreenTitle"] = "Choisir un niveau";
dictionaryVar["fr-fr"]["optionsRestartConfirmationText"] = "Attention !\n\nEn recommençant maintenant, vous perdrez votre progression pour le niveau en cours. Recommencer quand même ?";
dictionaryVar["fr-fr"]["optionsRestart"] = "Recommencer";
dictionaryVar["fr-fr"]["optionsSFXBig_on"] = "Avec son";
dictionaryVar["fr-fr"]["optionsSFXBig_off"] = "Sans son";
dictionaryVar["fr-fr"]["optionsAbout_title"] = "À propos";
dictionaryVar["fr-fr"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["fr-fr"]["optionsAbout_backBtn"] = "Retour";
dictionaryVar["fr-fr"]["optionsAbout_version"] = "Version :";
dictionaryVar["fr-fr"]["optionsAbout"] = "À propos";
dictionaryVar["fr-fr"]["levelEndScreenMedal"] = "RECORD BATTU !";
dictionaryVar["fr-fr"]["startScreenQuestionaire"] = "Un avis sur le jeu ?";
dictionaryVar["fr-fr"]["levelMapScreenWorld_0"] = "Choisir un niveau";
dictionaryVar["fr-fr"]["startScreenByTinglyGames"] = "Un jeu CoolGames";
dictionaryVar["fr-fr"]["optionsLang_de-de"] = "Allemand";
dictionaryVar["fr-fr"]["optionsLang_tr-tr"] = "Turc";
dictionaryVar["fr-fr"]["optionsAbout_header"] = "Développé par :";
dictionaryVar["fr-fr"]["levelEndScreenViewHighscoreBtn"] = "Voir les scores";
dictionaryVar["fr-fr"]["levelEndScreenSubmitHighscoreBtn"] = "Publier un score";
dictionaryVar["fr-fr"]["challengeStartScreenTitle_challengee_friend"] = "Votre adversaire :";
dictionaryVar["fr-fr"]["challengeStartTextScore"] = "Son score :";
dictionaryVar["fr-fr"]["challengeStartTextTime"] = "Son temps :";
dictionaryVar["fr-fr"]["challengeStartScreenToWin"] = "À gagner :";
dictionaryVar["fr-fr"]["challengeEndScreenWinnings"] = "Vous avez gagné <AMOUNT> fairpoints.";
dictionaryVar["fr-fr"]["challengeEndScreenOutcomeMessage_WON"] = "Vainqueur !";
dictionaryVar["fr-fr"]["challengeEndScreenOutcomeMessage_LOST"] = "Zut !";
dictionaryVar["fr-fr"]["challengeEndScreenOutcomeMessage_TIED"] = "Ex-aequo !";
dictionaryVar["fr-fr"]["challengeCancelConfirmText"] = "Si vous annulez, on vous remboursera le montant du pari moins les frais de pari. Voulez-vous continuer ? ";
dictionaryVar["fr-fr"]["challengeCancelConfirmBtn_yes"] = "Oui";
dictionaryVar["fr-fr"]["challengeCancelConfirmBtn_no"] = "Non";
dictionaryVar["fr-fr"]["challengeEndScreensBtn_submit"] = "Lancer le défi";
dictionaryVar["fr-fr"]["challengeEndScreenBtn_cancel"] = "Annuler le défi";
dictionaryVar["fr-fr"]["challengeEndScreenName_you"] = "Moi";
dictionaryVar["fr-fr"]["challengeEndScreenChallengeSend_error"] = "Une erreur est survenue. Veuillez réessayer ultérieurement.";
dictionaryVar["fr-fr"]["challengeEndScreenChallengeSend_success"] = "Défi lancé.";
dictionaryVar["fr-fr"]["challengeCancelMessage_error"] = "Une erreur est survenue. Veuillez réessayer ultérieurement.";
dictionaryVar["fr-fr"]["challengeCancelMessage_success"] = "Défi annulé.";
dictionaryVar["fr-fr"]["challengeEndScreenScoreSend_error"] = "Une erreur est survenue. Veuillez réessayer ultérieurement.";
dictionaryVar["fr-fr"]["challengeStartScreenTitle_challengee_stranger"] = "Votre adversaire :";
dictionaryVar["fr-fr"]["challengeStartScreenTitle_challenger_friend"] = "Votre adversaire :";
dictionaryVar["fr-fr"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["fr-fr"]["challengeStartTextTime_challenger"] = "Finissez le plus vite possible !";
dictionaryVar["fr-fr"]["challengeStartTextScore_challenger"] = "Essayez d’atteindre le plus haut score !";
dictionaryVar["fr-fr"]["challengeForfeitConfirmText"] = "Voulez-vous vraiment abandonner la partie ?";
dictionaryVar["fr-fr"]["challengeForfeitConfirmBtn_yes"] = "Oui";
dictionaryVar["fr-fr"]["challengeForfeitConfirmBtn_no"] = "Non";
dictionaryVar["fr-fr"]["challengeForfeitMessage_success"] = "Vous avez abandonné.";
dictionaryVar["fr-fr"]["challengeForfeitMessage_error"] = "Une erreur est survenue. Veuillez réessayer ultérieurement.";
dictionaryVar["fr-fr"]["optionsChallengeForfeit"] = "Abandonner";
dictionaryVar["fr-fr"]["optionsChallengeCancel"] = "Annuler";
dictionaryVar["fr-fr"]["challengeLoadingError_notValid"] = "Désolé, cette partie n'existe plus.";
dictionaryVar["fr-fr"]["challengeLoadingError_notStarted"] = "Une erreur de connexion est survenue. Veuillez réessayer ultérieurement.";
dictionaryVar["fr-fr"]["levelEndScreenHighScore_time"] = "Meilleur temps :";
dictionaryVar["fr-fr"]["levelEndScreenTotalScore_time"] = "Temps total :";
dictionaryVar["fr-fr"]["optionsLang_fr-fr"] = "Français";
dictionaryVar["fr-fr"]["optionsLang_ko-kr"] = "Coréen";
dictionaryVar["fr-fr"]["optionsLang_ar-eg"] = "Arabe";
dictionaryVar["fr-fr"]["optionsLang_es-es"] = "Espagnol";
dictionaryVar["fr-fr"]["optionsLang_pt-br"] = "Portugais - Brésilien";
dictionaryVar["fr-fr"]["optionsLang_ru-ru"] = "Russe";
dictionaryVar["fr-fr"]["optionsExit"] = "Quitter";
dictionaryVar["fr-fr"]["levelEndScreenTotalScore_number"] = "Score total :";
dictionaryVar["fr-fr"]["levelEndScreenHighScore_number"] = "Meilleur score :";
dictionaryVar["fr-fr"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> a 72 heures pour accepter votre défi. Si <NAME> refuse ou n’accepte pas dans ce délai vous serez remboursé le montant de votre pari et les frais de pari.";
dictionaryVar["fr-fr"]["challengeEndScreenChallengeSend_submessage_stranger"] = "Si personne n’accepte votre pari d’ici 72 heures, on vous remboursera le montant du pari y compris les frais.";
dictionaryVar["fr-fr"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["fr-fr"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["fr-fr"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["fr-fr"]["optionsLang_it-it"] = "Italian";
dictionaryVar["pt-br"] = dictionaryVar["pt-br"] || {};
dictionaryVar["pt-br"]["loadingScreenLoading"] = "Carregando...";
dictionaryVar["pt-br"]["startScreenPlay"] = "JOGAR";
dictionaryVar["pt-br"]["levelMapScreenTotalScore"] = "Pontuação";
dictionaryVar["pt-br"]["levelEndScreenTitle_level"] = "Nível <VALUE>";
dictionaryVar["pt-br"]["levelEndScreenTitle_difficulty"] = "Muito bem!";
dictionaryVar["pt-br"]["levelEndScreenTitle_endless"] = "Fase <VALUE>";
dictionaryVar["pt-br"]["levelEndScreenTotalScore"] = "Pontuação";
dictionaryVar["pt-br"]["levelEndScreenSubTitle_levelFailed"] = "Tente novamente";
dictionaryVar["pt-br"]["levelEndScreenTimeLeft"] = "Tempo restante";
dictionaryVar["pt-br"]["levelEndScreenTimeBonus"] = "Bônus de tempo";
dictionaryVar["pt-br"]["levelEndScreenHighScore"] = "Recorde";
dictionaryVar["pt-br"]["optionsStartScreen"] = "Menu principal";
dictionaryVar["pt-br"]["optionsQuit"] = "Sair";
dictionaryVar["pt-br"]["optionsResume"] = "Continuar";
dictionaryVar["pt-br"]["optionsTutorial"] = "Como jogar";
dictionaryVar["pt-br"]["optionsHighScore"] = "Recordes";
dictionaryVar["pt-br"]["optionsMoreGames"] = "Mais jogos";
dictionaryVar["pt-br"]["optionsDifficulty_easy"] = "Fácil";
dictionaryVar["pt-br"]["optionsDifficulty_medium"] = "Médio";
dictionaryVar["pt-br"]["optionsDifficulty_hard"] = "Difícil";
dictionaryVar["pt-br"]["optionsMusic_on"] = "Sim";
dictionaryVar["pt-br"]["optionsMusic_off"] = "Não";
dictionaryVar["pt-br"]["optionsSFX_on"] = "Sim";
dictionaryVar["pt-br"]["optionsSFX_off"] = "Não";
dictionaryVar["pt-br"]["optionsLang_en-us"] = "Inglês (EUA)";
dictionaryVar["pt-br"]["optionsLang_en-gb"] = "Inglês (GB)";
dictionaryVar["pt-br"]["optionsLang_nl-nl"] = "Holandês";
dictionaryVar["pt-br"]["gameEndScreenTitle"] = "Parabéns!\nVocê concluiu o jogo.";
dictionaryVar["pt-br"]["gameEndScreenBtnText"] = "Continuar";
dictionaryVar["pt-br"]["optionsTitle"] = "Configurações";
dictionaryVar["pt-br"]["optionsQuitConfirmationText"] = "Atenção!\n\nSe você sair agora, perderá todo progresso realizado neste nível. Deseja mesmo sair?";
dictionaryVar["pt-br"]["optionsQuitConfirmBtn_No"] = "Não";
dictionaryVar["pt-br"]["optionsQuitConfirmBtn_Yes"] = "Sim, tenho certeza.";
dictionaryVar["pt-br"]["levelMapScreenTitle"] = "Selecione um nível";
dictionaryVar["pt-br"]["optionsRestartConfirmationText"] = "Atenção!\n\nSe você reiniciar agora, perderá todo progresso realizado neste nível. Deseja mesmo reiniciar?";
dictionaryVar["pt-br"]["optionsRestart"] = "Reiniciar";
dictionaryVar["pt-br"]["optionsSFXBig_on"] = "Com som";
dictionaryVar["pt-br"]["optionsSFXBig_off"] = "Sem som";
dictionaryVar["pt-br"]["optionsAbout_title"] = "Sobre";
dictionaryVar["pt-br"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["pt-br"]["optionsAbout_backBtn"] = "Voltar";
dictionaryVar["pt-br"]["optionsAbout_version"] = "versão:";
dictionaryVar["pt-br"]["optionsAbout"] = "Sobre";
dictionaryVar["pt-br"]["levelEndScreenMedal"] = "MELHOROU!";
dictionaryVar["pt-br"]["startScreenQuestionaire"] = "O que você achou?";
dictionaryVar["pt-br"]["levelMapScreenWorld_0"] = "Selecione um nível";
dictionaryVar["pt-br"]["startScreenByTinglyGames"] = "da: CoolGames";
dictionaryVar["pt-br"]["optionsLang_de-de"] = "Alemão";
dictionaryVar["pt-br"]["optionsLang_tr-tr"] = "Turco";
dictionaryVar["pt-br"]["optionsAbout_header"] = "Desenvolvido por:";
dictionaryVar["pt-br"]["levelEndScreenViewHighscoreBtn"] = "Ver pontuações";
dictionaryVar["pt-br"]["levelEndScreenSubmitHighscoreBtn"] = "Enviar recorde";
dictionaryVar["pt-br"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["pt-br"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["pt-br"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["pt-br"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["pt-br"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["pt-br"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["pt-br"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["pt-br"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["pt-br"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["pt-br"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["pt-br"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["pt-br"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["pt-br"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["pt-br"]["challengeEndScreenName_you"] = "You";
dictionaryVar["pt-br"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["pt-br"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["pt-br"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["pt-br"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["pt-br"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["pt-br"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["pt-br"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["pt-br"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["pt-br"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["pt-br"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["pt-br"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["pt-br"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["pt-br"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["pt-br"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["pt-br"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["pt-br"]["optionsChallengeForfeit"] = "Desistir";
dictionaryVar["pt-br"]["optionsChallengeCancel"] = "Sair do Jogo";
dictionaryVar["pt-br"]["challengeLoadingError_notValid"] = "Desculpe, este desafio não é mais válido.";
dictionaryVar["pt-br"]["challengeLoadingError_notStarted"] = "Impossível conectar ao servidor. Por favor, tente novamente mais tarde.";
dictionaryVar["pt-br"]["levelEndScreenHighScore_time"] = "Tempo recorde:";
dictionaryVar["pt-br"]["levelEndScreenTotalScore_time"] = "Tempo total:";
dictionaryVar["pt-br"]["optionsLang_fr-fr"] = "Francês";
dictionaryVar["pt-br"]["optionsLang_ko-kr"] = "Coreano";
dictionaryVar["pt-br"]["optionsLang_ar-eg"] = "Árabe";
dictionaryVar["pt-br"]["optionsLang_es-es"] = "Espanhol";
dictionaryVar["pt-br"]["optionsLang_pt-br"] = "Português do Brasil";
dictionaryVar["pt-br"]["optionsLang_ru-ru"] = "Russo";
dictionaryVar["pt-br"]["optionsExit"] = "Saída";
dictionaryVar["pt-br"]["levelEndScreenTotalScore_number"] = "Pontuação total:";
dictionaryVar["pt-br"]["levelEndScreenHighScore_number"] = "Pontuação máxima:";
dictionaryVar["pt-br"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["pt-br"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["pt-br"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["pt-br"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["pt-br"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["pt-br"]["optionsLang_it-it"] = "Italian";
dictionaryVar["es-es"] = dictionaryVar["es-es"] || {};
dictionaryVar["es-es"]["loadingScreenLoading"] = "Cargando...";
dictionaryVar["es-es"]["startScreenPlay"] = "JUGAR";
dictionaryVar["es-es"]["levelMapScreenTotalScore"] = "Punt. total";
dictionaryVar["es-es"]["levelEndScreenTitle_level"] = "Nivel <VALUE>";
dictionaryVar["es-es"]["levelEndScreenTitle_difficulty"] = "¡Muy bien!";
dictionaryVar["es-es"]["levelEndScreenTitle_endless"] = "Fase <VALUE>";
dictionaryVar["es-es"]["levelEndScreenTotalScore"] = "Punt. total";
dictionaryVar["es-es"]["levelEndScreenSubTitle_levelFailed"] = "Nivel fallido";
dictionaryVar["es-es"]["levelEndScreenTimeLeft"] = "Tiempo restante";
dictionaryVar["es-es"]["levelEndScreenTimeBonus"] = "Bonif. tiempo";
dictionaryVar["es-es"]["levelEndScreenHighScore"] = "Récord";
dictionaryVar["es-es"]["optionsStartScreen"] = "Menú principal";
dictionaryVar["es-es"]["optionsQuit"] = "Salir";
dictionaryVar["es-es"]["optionsResume"] = "Seguir";
dictionaryVar["es-es"]["optionsTutorial"] = "Cómo jugar";
dictionaryVar["es-es"]["optionsHighScore"] = "Récords";
dictionaryVar["es-es"]["optionsMoreGames"] = "Más juegos";
dictionaryVar["es-es"]["optionsDifficulty_easy"] = "Fácil";
dictionaryVar["es-es"]["optionsDifficulty_medium"] = "Normal";
dictionaryVar["es-es"]["optionsDifficulty_hard"] = "Difícil";
dictionaryVar["es-es"]["optionsMusic_on"] = "Sí";
dictionaryVar["es-es"]["optionsMusic_off"] = "No";
dictionaryVar["es-es"]["optionsSFX_on"] = "Sí";
dictionaryVar["es-es"]["optionsSFX_off"] = "No";
dictionaryVar["es-es"]["optionsLang_en-us"] = "Inglés (EE.UU.)";
dictionaryVar["es-es"]["optionsLang_en-gb"] = "Inglés (GB)";
dictionaryVar["es-es"]["optionsLang_nl-nl"] = "Neerlandés";
dictionaryVar["es-es"]["gameEndScreenTitle"] = "¡Enhorabuena!\nHas terminado el juego.";
dictionaryVar["es-es"]["gameEndScreenBtnText"] = "Continuar";
dictionaryVar["es-es"]["optionsTitle"] = "Ajustes";
dictionaryVar["es-es"]["optionsQuitConfirmationText"] = "¡Aviso!\n\nSi sales ahora, perderás el progreso que hayas realizado en el nivel. ¿Seguro que quieres salir?";
dictionaryVar["es-es"]["optionsQuitConfirmBtn_No"] = "No";
dictionaryVar["es-es"]["optionsQuitConfirmBtn_Yes"] = "Sí, seguro";
dictionaryVar["es-es"]["levelMapScreenTitle"] = "Elige un nivel";
dictionaryVar["es-es"]["optionsRestartConfirmationText"] = "¡Aviso!\n\nSi reinicias ahora, perderás el progreso que hayas realizado en el nivel. ¿Seguro que quieres reiniciar?";
dictionaryVar["es-es"]["optionsRestart"] = "Reiniciar";
dictionaryVar["es-es"]["optionsSFXBig_on"] = "Sonido sí";
dictionaryVar["es-es"]["optionsSFXBig_off"] = "Sonido no";
dictionaryVar["es-es"]["optionsAbout_title"] = "Acerca de";
dictionaryVar["es-es"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["es-es"]["optionsAbout_backBtn"] = "Atrás";
dictionaryVar["es-es"]["optionsAbout_version"] = "versión:";
dictionaryVar["es-es"]["optionsAbout"] = "Acerca de";
dictionaryVar["es-es"]["levelEndScreenMedal"] = "¡SUPERADO!";
dictionaryVar["es-es"]["startScreenQuestionaire"] = "¿Qué te parece?";
dictionaryVar["es-es"]["levelMapScreenWorld_0"] = "Elige un nivel";
dictionaryVar["es-es"]["startScreenByTinglyGames"] = "de: CoolGames";
dictionaryVar["es-es"]["optionsLang_de-de"] = "Alemán";
dictionaryVar["es-es"]["optionsLang_tr-tr"] = "Turco";
dictionaryVar["es-es"]["optionsAbout_header"] = "Desarrollado por:";
dictionaryVar["es-es"]["levelEndScreenViewHighscoreBtn"] = "Ver puntuaciones";
dictionaryVar["es-es"]["levelEndScreenSubmitHighscoreBtn"] = "Enviar puntuación";
dictionaryVar["es-es"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["es-es"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["es-es"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["es-es"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["es-es"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["es-es"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["es-es"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["es-es"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["es-es"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["es-es"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["es-es"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["es-es"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["es-es"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["es-es"]["challengeEndScreenName_you"] = "You";
dictionaryVar["es-es"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["es-es"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["es-es"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["es-es"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["es-es"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["es-es"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["es-es"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["es-es"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["es-es"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["es-es"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["es-es"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["es-es"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["es-es"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["es-es"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["es-es"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["es-es"]["optionsChallengeForfeit"] = "Rendirse";
dictionaryVar["es-es"]["optionsChallengeCancel"] = "Abandonar";
dictionaryVar["es-es"]["challengeLoadingError_notValid"] = "Lo sentimos, este reto ya no es válido.";
dictionaryVar["es-es"]["challengeLoadingError_notStarted"] = "Imposible conectar con el servidor. Inténtalo más tarde.";
dictionaryVar["es-es"]["levelEndScreenHighScore_time"] = "Mejor tiempo:";
dictionaryVar["es-es"]["levelEndScreenTotalScore_time"] = "Tiempo total:";
dictionaryVar["es-es"]["optionsLang_fr-fr"] = "Francés";
dictionaryVar["es-es"]["optionsLang_ko-kr"] = "Coreano";
dictionaryVar["es-es"]["optionsLang_ar-eg"] = "Árabe";
dictionaryVar["es-es"]["optionsLang_es-es"] = "Español";
dictionaryVar["es-es"]["optionsLang_pt-br"] = "Portugués brasileño";
dictionaryVar["es-es"]["optionsLang_ru-ru"] = "Ruso";
dictionaryVar["es-es"]["optionsExit"] = "Salir";
dictionaryVar["es-es"]["levelEndScreenTotalScore_number"] = "Puntos totales:";
dictionaryVar["es-es"]["levelEndScreenHighScore_number"] = "Mejor puntuación:";
dictionaryVar["es-es"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["es-es"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["es-es"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["es-es"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["es-es"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["es-es"]["optionsLang_it-it"] = "Italian";
dictionaryVar["tr-tr"] = dictionaryVar["tr-tr"] || {};
dictionaryVar["tr-tr"]["loadingScreenLoading"] = "Yükleniyor...";
dictionaryVar["tr-tr"]["startScreenPlay"] = "OYNA";
dictionaryVar["tr-tr"]["levelMapScreenTotalScore"] = "Toplam skor";
dictionaryVar["tr-tr"]["levelEndScreenTitle_level"] = "Seviye <VALUE>";
dictionaryVar["tr-tr"]["levelEndScreenTitle_difficulty"] = "Bravo!";
dictionaryVar["tr-tr"]["levelEndScreenTitle_endless"] = "Seviye <VALUE>";
dictionaryVar["tr-tr"]["levelEndScreenTotalScore"] = "Toplam skor";
dictionaryVar["tr-tr"]["levelEndScreenSubTitle_levelFailed"] = "Seviye başarısız";
dictionaryVar["tr-tr"]["levelEndScreenTimeLeft"] = "Kalan Süre";
dictionaryVar["tr-tr"]["levelEndScreenTimeBonus"] = "Süre Bonusu";
dictionaryVar["tr-tr"]["levelEndScreenHighScore"] = "Yüksek skor";
dictionaryVar["tr-tr"]["optionsStartScreen"] = "Ana menü";
dictionaryVar["tr-tr"]["optionsQuit"] = "Çık";
dictionaryVar["tr-tr"]["optionsResume"] = "Devam et";
dictionaryVar["tr-tr"]["optionsTutorial"] = "Nasıl oynanır";
dictionaryVar["tr-tr"]["optionsHighScore"] = "Yüksek skorlar";
dictionaryVar["tr-tr"]["optionsMoreGames"] = "Daha Fazla Oyun";
dictionaryVar["tr-tr"]["optionsDifficulty_easy"] = "Kolay";
dictionaryVar["tr-tr"]["optionsDifficulty_medium"] = "Orta";
dictionaryVar["tr-tr"]["optionsDifficulty_hard"] = "Zorluk";
dictionaryVar["tr-tr"]["optionsMusic_on"] = "Açık";
dictionaryVar["tr-tr"]["optionsMusic_off"] = "Kapalı";
dictionaryVar["tr-tr"]["optionsSFX_on"] = "Açık";
dictionaryVar["tr-tr"]["optionsSFX_off"] = "Kapalı";
dictionaryVar["tr-tr"]["optionsLang_en-us"] = "İngilizce (US)";
dictionaryVar["tr-tr"]["optionsLang_en-gb"] = "İngilizce (GB)";
dictionaryVar["tr-tr"]["optionsLang_nl-nl"] = "Hollandaca";
dictionaryVar["tr-tr"]["gameEndScreenTitle"] = "Tebrikler!\nOyunu tamamladın.";
dictionaryVar["tr-tr"]["gameEndScreenBtnText"] = "Devam";
dictionaryVar["tr-tr"]["optionsTitle"] = "Ayarlar";
dictionaryVar["tr-tr"]["optionsQuitConfirmationText"] = "Dikkat!\nŞimdi çıkarsan bu seviyede yapılan tüm ilerleme kaybedilecek. Çıkmak istediğinizden emin misiniz?";
dictionaryVar["tr-tr"]["optionsQuitConfirmBtn_No"] = "Hayır";
dictionaryVar["tr-tr"]["optionsQuitConfirmBtn_Yes"] = "Evet, eminim";
dictionaryVar["tr-tr"]["levelMapScreenTitle"] = "Bir seviye seç";
dictionaryVar["tr-tr"]["optionsRestartConfirmationText"] = "Dikkat!\nŞimdi tekrar başlarsan bu seviyede yapılan tüm ilerleme kaybedilecek. Baştan başlamak istediğinden emin misin?";
dictionaryVar["tr-tr"]["optionsRestart"] = "Tekrar başlat";
dictionaryVar["tr-tr"]["optionsSFXBig_on"] = "Ses açık";
dictionaryVar["tr-tr"]["optionsSFXBig_off"] = "Ses kapalı";
dictionaryVar["tr-tr"]["optionsAbout_title"] = "Hakkında";
dictionaryVar["tr-tr"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["tr-tr"]["optionsAbout_backBtn"] = "Geri";
dictionaryVar["tr-tr"]["optionsAbout_version"] = "sürüm:";
dictionaryVar["tr-tr"]["optionsAbout"] = "Hakkında";
dictionaryVar["tr-tr"]["levelEndScreenMedal"] = "İYİLEŞTİ!";
dictionaryVar["tr-tr"]["startScreenQuestionaire"] = "Ne dersin?";
dictionaryVar["tr-tr"]["levelMapScreenWorld_0"] = "Bir seviye seç";
dictionaryVar["tr-tr"]["startScreenByTinglyGames"] = "tarafından: CoolGames";
dictionaryVar["tr-tr"]["optionsLang_de-de"] = "Almanca";
dictionaryVar["tr-tr"]["optionsLang_tr-tr"] = "Türkçe";
dictionaryVar["tr-tr"]["optionsAbout_header"] = "Hazırlayan:";
dictionaryVar["tr-tr"]["levelEndScreenViewHighscoreBtn"] = "Puanları göster:";
dictionaryVar["tr-tr"]["levelEndScreenSubmitHighscoreBtn"] = "Puan gönder";
dictionaryVar["tr-tr"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["tr-tr"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["tr-tr"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["tr-tr"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["tr-tr"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["tr-tr"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["tr-tr"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["tr-tr"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["tr-tr"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["tr-tr"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["tr-tr"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["tr-tr"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["tr-tr"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["tr-tr"]["challengeEndScreenName_you"] = "You";
dictionaryVar["tr-tr"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["tr-tr"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["tr-tr"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["tr-tr"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["tr-tr"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["tr-tr"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["tr-tr"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["tr-tr"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["tr-tr"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["tr-tr"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["tr-tr"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["tr-tr"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["tr-tr"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["tr-tr"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["tr-tr"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["tr-tr"]["optionsChallengeForfeit"] = "Vazgeç";
dictionaryVar["tr-tr"]["optionsChallengeCancel"] = "Çıkış";
dictionaryVar["tr-tr"]["challengeLoadingError_notValid"] = "Üzgünüz, bu zorluk artık geçerli değil.";
dictionaryVar["tr-tr"]["challengeLoadingError_notStarted"] = "Sunucuya bağlanılamıyor. Lütfen daha sonra tekrar deneyin.";
dictionaryVar["tr-tr"]["levelEndScreenHighScore_time"] = "En İyi Zaman:";
dictionaryVar["tr-tr"]["levelEndScreenTotalScore_time"] = "Toplam Zaman:";
dictionaryVar["tr-tr"]["optionsLang_fr-fr"] = "Fransızca";
dictionaryVar["tr-tr"]["optionsLang_ko-kr"] = "Korece";
dictionaryVar["tr-tr"]["optionsLang_ar-eg"] = "Arapça";
dictionaryVar["tr-tr"]["optionsLang_es-es"] = "İspanyolca";
dictionaryVar["tr-tr"]["optionsLang_pt-br"] = "Brezilya Portekizcesi";
dictionaryVar["tr-tr"]["optionsLang_ru-ru"] = "Rusça";
dictionaryVar["tr-tr"]["optionsExit"] = "Çıkış";
dictionaryVar["tr-tr"]["levelEndScreenTotalScore_number"] = "Toplam Puan:";
dictionaryVar["tr-tr"]["levelEndScreenHighScore_number"] = "Yüksek Puan:";
dictionaryVar["tr-tr"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["tr-tr"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["tr-tr"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["tr-tr"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["tr-tr"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["tr-tr"]["optionsLang_it-it"] = "Italian";
dictionaryVar["ru-ru"] = dictionaryVar["ru-ru"] || {};
dictionaryVar["ru-ru"]["loadingScreenLoading"] = "Загрузка...";
dictionaryVar["ru-ru"]["startScreenPlay"] = "ИГРАТЬ";
dictionaryVar["ru-ru"]["levelMapScreenTotalScore"] = "Общий счет";
dictionaryVar["ru-ru"]["levelEndScreenTitle_level"] = "Уровень <VALUE>";
dictionaryVar["ru-ru"]["levelEndScreenTitle_difficulty"] = "Хороший результат!";
dictionaryVar["ru-ru"]["levelEndScreenTitle_endless"] = "Этап <VALUE>";
dictionaryVar["ru-ru"]["levelEndScreenTotalScore"] = "Общий счет";
dictionaryVar["ru-ru"]["levelEndScreenSubTitle_levelFailed"] = "Уровень не пройден";
dictionaryVar["ru-ru"]["levelEndScreenTimeLeft"] = "Оставшееся время";
dictionaryVar["ru-ru"]["levelEndScreenTimeBonus"] = "Дополнительное время";
dictionaryVar["ru-ru"]["levelEndScreenHighScore"] = "Рекорд";
dictionaryVar["ru-ru"]["optionsStartScreen"] = "Главное меню";
dictionaryVar["ru-ru"]["optionsQuit"] = "Выйти";
dictionaryVar["ru-ru"]["optionsResume"] = "Продолжить";
dictionaryVar["ru-ru"]["optionsTutorial"] = "Как играть";
dictionaryVar["ru-ru"]["optionsHighScore"] = "Рекорды";
dictionaryVar["ru-ru"]["optionsMoreGames"] = "Больше игр";
dictionaryVar["ru-ru"]["optionsDifficulty_easy"] = "Легкий";
dictionaryVar["ru-ru"]["optionsDifficulty_medium"] = "Средний";
dictionaryVar["ru-ru"]["optionsDifficulty_hard"] = "Сложный";
dictionaryVar["ru-ru"]["optionsMusic_on"] = "Вкл.";
dictionaryVar["ru-ru"]["optionsMusic_off"] = "Выкл.";
dictionaryVar["ru-ru"]["optionsSFX_on"] = "Вкл.";
dictionaryVar["ru-ru"]["optionsSFX_off"] = "Выкл.";
dictionaryVar["ru-ru"]["optionsLang_en-us"] = "Английский (США)";
dictionaryVar["ru-ru"]["optionsLang_en-gb"] = "Английский (ВБ)";
dictionaryVar["ru-ru"]["optionsLang_nl-nl"] = "Нидерландский";
dictionaryVar["ru-ru"]["gameEndScreenTitle"] = "Поздравляем!\nВы прошли игру.";
dictionaryVar["ru-ru"]["gameEndScreenBtnText"] = "Продолжить";
dictionaryVar["ru-ru"]["optionsTitle"] = "Настройки";
dictionaryVar["ru-ru"]["optionsQuitConfirmationText"] = "Внимание!\n\nЕсли вы выйдете сейчас, уровень не будет засчитан. Вы уверены, что хотите выйти?";
dictionaryVar["ru-ru"]["optionsQuitConfirmBtn_No"] = "Нет";
dictionaryVar["ru-ru"]["optionsQuitConfirmBtn_Yes"] = "Да, выйти";
dictionaryVar["ru-ru"]["levelMapScreenTitle"] = "Выберите уровень";
dictionaryVar["ru-ru"]["optionsRestartConfirmationText"] = "Внимание!\n\nЕсли вы сейчас начнете игру заново, уровень не будет засчитан. Вы уверены, что хотите начать заново?";
dictionaryVar["ru-ru"]["optionsRestart"] = "Заново";
dictionaryVar["ru-ru"]["optionsSFXBig_on"] = "Звук вкл.";
dictionaryVar["ru-ru"]["optionsSFXBig_off"] = "Звук выкл.";
dictionaryVar["ru-ru"]["optionsAbout_title"] = "О программе";
dictionaryVar["ru-ru"]["optionsAbout_text"] = "© CoolGames\nwww.coolgames.com\n2017";
dictionaryVar["ru-ru"]["optionsAbout_backBtn"] = "Назад";
dictionaryVar["ru-ru"]["optionsAbout_version"] = "Версия:";
dictionaryVar["ru-ru"]["optionsAbout"] = "О программе";
dictionaryVar["ru-ru"]["levelEndScreenMedal"] = "НОВЫЙ РЕКОРД!";
dictionaryVar["ru-ru"]["startScreenQuestionaire"] = "Как вам игра?";
dictionaryVar["ru-ru"]["levelMapScreenWorld_0"] = "Выберите уровень";
dictionaryVar["ru-ru"]["startScreenByTinglyGames"] = "Разработчики: CoolGames";
dictionaryVar["ru-ru"]["optionsLang_de-de"] = "Немецкий";
dictionaryVar["ru-ru"]["optionsLang_tr-tr"] = "Турецкий";
dictionaryVar["ru-ru"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["ru-ru"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["ru-ru"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["ru-ru"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["ru-ru"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["ru-ru"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["ru-ru"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["ru-ru"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["ru-ru"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["ru-ru"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["ru-ru"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["ru-ru"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["ru-ru"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["ru-ru"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["ru-ru"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["ru-ru"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["ru-ru"]["challengeEndScreenName_you"] = "You";
dictionaryVar["ru-ru"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["ru-ru"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["ru-ru"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["ru-ru"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["ru-ru"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["ru-ru"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["ru-ru"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["ru-ru"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["ru-ru"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["ru-ru"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["ru-ru"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["ru-ru"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["ru-ru"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["ru-ru"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["ru-ru"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["ru-ru"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["ru-ru"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["ru-ru"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["ru-ru"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["ru-ru"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["ru-ru"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["ru-ru"]["optionsLang_fr-fr"] = "Французский";
dictionaryVar["ru-ru"]["optionsLang_ko-kr"] = "Корейский";
dictionaryVar["ru-ru"]["optionsLang_ar-eg"] = "Арабский";
dictionaryVar["ru-ru"]["optionsLang_es-es"] = "Испанский";
dictionaryVar["ru-ru"]["optionsLang_pt-br"] = "Бразильский португальский";
dictionaryVar["ru-ru"]["optionsLang_ru-ru"] = "Русский";
dictionaryVar["ru-ru"]["optionsExit"] = "Exit";
dictionaryVar["ru-ru"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["ru-ru"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["ru-ru"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["ru-ru"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["ru-ru"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["ru-ru"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["ru-ru"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["ru-ru"]["optionsLang_it-it"] = "Italian";
dictionaryVar["ar-eg"] = dictionaryVar["ar-eg"] || {};
dictionaryVar["ar-eg"]["loadingScreenLoading"] = "يتم الآن التحميل...";
dictionaryVar["ar-eg"]["startScreenPlay"] = "تشغيل";
dictionaryVar["ar-eg"]["levelMapScreenTotalScore"] = "النتيجة الإجمالية";
dictionaryVar["ar-eg"]["levelEndScreenTitle_level"] = "المستوى <VALUE>";
dictionaryVar["ar-eg"]["levelEndScreenTitle_difficulty"] = "أحسنت!";
dictionaryVar["ar-eg"]["levelEndScreenTitle_endless"] = "المرحلة <VALUE>";
dictionaryVar["ar-eg"]["levelEndScreenTotalScore"] = "النتيجة الإجمالية";
dictionaryVar["ar-eg"]["levelEndScreenSubTitle_levelFailed"] = "لقد فشلت في اجتياز هذا المستوى";
dictionaryVar["ar-eg"]["levelEndScreenTimeLeft"] = "الوقت المتبقي";
dictionaryVar["ar-eg"]["levelEndScreenTimeBonus"] = "مكافأة الوقت";
dictionaryVar["ar-eg"]["levelEndScreenHighScore"] = "أعلى نتيجة";
dictionaryVar["ar-eg"]["optionsStartScreen"] = "القائمة الرئيسية";
dictionaryVar["ar-eg"]["optionsQuit"] = "الخروج من اللعبة";
dictionaryVar["ar-eg"]["optionsResume"] = "استئناف";
dictionaryVar["ar-eg"]["optionsTutorial"] = "طريقة اللعب";
dictionaryVar["ar-eg"]["optionsHighScore"] = "أعلى النتائج";
dictionaryVar["ar-eg"]["optionsMoreGames"] = "المزيد من الألعاب";
dictionaryVar["ar-eg"]["optionsDifficulty_easy"] = "سهل";
dictionaryVar["ar-eg"]["optionsDifficulty_medium"] = "متوسط";
dictionaryVar["ar-eg"]["optionsDifficulty_hard"] = "صعب";
dictionaryVar["ar-eg"]["optionsMusic_on"] = "تشغيل الموسيقى";
dictionaryVar["ar-eg"]["optionsMusic_off"] = "إيقاف الموسيقى";
dictionaryVar["ar-eg"]["optionsSFX_on"] = "تشغيل المؤثرات الصوتية";
dictionaryVar["ar-eg"]["optionsSFX_off"] = "إيقاف المؤثرات الصوتية";
dictionaryVar["ar-eg"]["optionsLang_en-us"] = "الإنجليزية (الولايات المتحدة)";
dictionaryVar["ar-eg"]["optionsLang_en-gb"] = "الإنجليزية (المملكة المتحدة)";
dictionaryVar["ar-eg"]["optionsLang_nl-nl"] = "الهولندية";
dictionaryVar["ar-eg"]["gameEndScreenTitle"] = "تهانينا!\nلقد أكملت اللعبة.";
dictionaryVar["ar-eg"]["gameEndScreenBtnText"] = "متابعة";
dictionaryVar["ar-eg"]["optionsTitle"] = "الإعدادات";
dictionaryVar["ar-eg"]["optionsQuitConfirmationText"] = "انتبه!n\n\إذا خرجت من اللعبة الآن، فستفقد كل التقدم الذي أحرزته خلال هذا المستوى. هل أنت متأكد من أنك تريد الخروج من اللعبة؟";
dictionaryVar["ar-eg"]["optionsQuitConfirmBtn_No"] = "لا";
dictionaryVar["ar-eg"]["optionsQuitConfirmBtn_Yes"] = "نعم، متأكد";
dictionaryVar["ar-eg"]["levelMapScreenTitle"] = "تحديد مستوى";
dictionaryVar["ar-eg"]["optionsRestartConfirmationText"] = "انتبه!\n\nإذا قمت بإعادة التشغيل الآن، فستفقد كل التقدم الذي أحرزته خلال هذا المستوى. هل أنت متأكد من أنك تريد إعادة التشغيل؟";
dictionaryVar["ar-eg"]["optionsRestart"] = "إعادة التشغيل";
dictionaryVar["ar-eg"]["optionsSFXBig_on"] = "تشغيل الصوت";
dictionaryVar["ar-eg"]["optionsSFXBig_off"] = "إيقاف الصوت";
dictionaryVar["ar-eg"]["optionsAbout_title"] = "حول";
dictionaryVar["ar-eg"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["ar-eg"]["optionsAbout_backBtn"] = "السابق";
dictionaryVar["ar-eg"]["optionsAbout_version"] = "الإصدار:";
dictionaryVar["ar-eg"]["optionsAbout"] = "حول";
dictionaryVar["ar-eg"]["levelEndScreenMedal"] = "لقد تحسّنت!";
dictionaryVar["ar-eg"]["startScreenQuestionaire"] = "ما رأيك؟";
dictionaryVar["ar-eg"]["levelMapScreenWorld_0"] = "تحديد مستوى";
dictionaryVar["ar-eg"]["startScreenByTinglyGames"] = "بواسطة: CoolGames";
dictionaryVar["ar-eg"]["optionsLang_de-de"] = "الألمانية";
dictionaryVar["ar-eg"]["optionsLang_tr-tr"] = "التركية";
dictionaryVar["ar-eg"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["ar-eg"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["ar-eg"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["ar-eg"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["ar-eg"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["ar-eg"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["ar-eg"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["ar-eg"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["ar-eg"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["ar-eg"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["ar-eg"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["ar-eg"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["ar-eg"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["ar-eg"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["ar-eg"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["ar-eg"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["ar-eg"]["challengeEndScreenName_you"] = "You";
dictionaryVar["ar-eg"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["ar-eg"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["ar-eg"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["ar-eg"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["ar-eg"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["ar-eg"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["ar-eg"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["ar-eg"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["ar-eg"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["ar-eg"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["ar-eg"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["ar-eg"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["ar-eg"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["ar-eg"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["ar-eg"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["ar-eg"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["ar-eg"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["ar-eg"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["ar-eg"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["ar-eg"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["ar-eg"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["ar-eg"]["optionsLang_fr-fr"] = "الفرنسية";
dictionaryVar["ar-eg"]["optionsLang_ko-kr"] = "الكورية";
dictionaryVar["ar-eg"]["optionsLang_ar-eg"] = "العربية";
dictionaryVar["ar-eg"]["optionsLang_es-es"] = "الإسبانية";
dictionaryVar["ar-eg"]["optionsLang_pt-br"] = "البرازيلية - البرتغالية";
dictionaryVar["ar-eg"]["optionsLang_ru-ru"] = "الروسية";
dictionaryVar["ar-eg"]["optionsExit"] = "Exit";
dictionaryVar["ar-eg"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["ar-eg"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["ar-eg"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["ar-eg"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["ar-eg"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["ar-eg"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["ar-eg"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["ar-eg"]["optionsLang_it-it"] = "Italian";
dictionaryVar["ko-kr"] = dictionaryVar["ko-kr"] || {};
dictionaryVar["ko-kr"]["loadingScreenLoading"] = "불러오기 중...";
dictionaryVar["ko-kr"]["startScreenPlay"] = "PLAY";
dictionaryVar["ko-kr"]["levelMapScreenTotalScore"] = "총 점수";
dictionaryVar["ko-kr"]["levelEndScreenTitle_level"] = "레벨 <VALUE>";
dictionaryVar["ko-kr"]["levelEndScreenTitle_difficulty"] = "잘 했어요!";
dictionaryVar["ko-kr"]["levelEndScreenTitle_endless"] = "스테이지 <VALUE>";
dictionaryVar["ko-kr"]["levelEndScreenTotalScore"] = "총 점수";
dictionaryVar["ko-kr"]["levelEndScreenSubTitle_levelFailed"] = "레벨 실패";
dictionaryVar["ko-kr"]["levelEndScreenTimeLeft"] = "남은 시간";
dictionaryVar["ko-kr"]["levelEndScreenTimeBonus"] = "시간 보너스";
dictionaryVar["ko-kr"]["levelEndScreenHighScore"] = "최고 점수";
dictionaryVar["ko-kr"]["optionsStartScreen"] = "메인 메뉴";
dictionaryVar["ko-kr"]["optionsQuit"] = "종료";
dictionaryVar["ko-kr"]["optionsResume"] = "계속";
dictionaryVar["ko-kr"]["optionsTutorial"] = "게임 방법";
dictionaryVar["ko-kr"]["optionsHighScore"] = "최고 점수";
dictionaryVar["ko-kr"]["optionsMoreGames"] = "더 많은 게임";
dictionaryVar["ko-kr"]["optionsDifficulty_easy"] = "간단";
dictionaryVar["ko-kr"]["optionsDifficulty_medium"] = "중";
dictionaryVar["ko-kr"]["optionsDifficulty_hard"] = "상";
dictionaryVar["ko-kr"]["optionsMusic_on"] = "켜기";
dictionaryVar["ko-kr"]["optionsMusic_off"] = "끄기";
dictionaryVar["ko-kr"]["optionsSFX_on"] = "켜기";
dictionaryVar["ko-kr"]["optionsSFX_off"] = "끄기";
dictionaryVar["ko-kr"]["optionsLang_en-us"] = "영어(US)";
dictionaryVar["ko-kr"]["optionsLang_en-gb"] = "영어(GB)";
dictionaryVar["ko-kr"]["optionsLang_nl-nl"] = "네덜란드어";
dictionaryVar["ko-kr"]["gameEndScreenTitle"] = "축하합니다!\n게임을 완료했습니다.";
dictionaryVar["ko-kr"]["gameEndScreenBtnText"] = "계속";
dictionaryVar["ko-kr"]["optionsTitle"] = "설정";
dictionaryVar["ko-kr"]["optionsQuitConfirmationText"] = "주의!\n\n지금 종료하면 이 레벨의 모든 진행 내용을 잃게됩니다. 정말 종료하시겠습니까?";
dictionaryVar["ko-kr"]["optionsQuitConfirmBtn_No"] = "아니오";
dictionaryVar["ko-kr"]["optionsQuitConfirmBtn_Yes"] = "네, 확실합니다";
dictionaryVar["ko-kr"]["levelMapScreenTitle"] = "레벨 선택";
dictionaryVar["ko-kr"]["optionsRestartConfirmationText"] = "주의!\n\n지금 다시 시작하면 이 레벨의 모든 진행 내용을 잃게됩니다. 정말 다시 시작하시겠습니까?";
dictionaryVar["ko-kr"]["optionsRestart"] = "다시 시작";
dictionaryVar["ko-kr"]["optionsSFXBig_on"] = "음향 켜기";
dictionaryVar["ko-kr"]["optionsSFXBig_off"] = "음향 끄기";
dictionaryVar["ko-kr"]["optionsAbout_title"] = "관련 정보";
dictionaryVar["ko-kr"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["ko-kr"]["optionsAbout_backBtn"] = "뒤로";
dictionaryVar["ko-kr"]["optionsAbout_version"] = "버전:";
dictionaryVar["ko-kr"]["optionsAbout"] = "관련 정보";
dictionaryVar["ko-kr"]["levelEndScreenMedal"] = "향상했군요!";
dictionaryVar["ko-kr"]["startScreenQuestionaire"] = "어떻게 생각하세요?";
dictionaryVar["ko-kr"]["levelMapScreenWorld_0"] = "레벨 선택";
dictionaryVar["ko-kr"]["startScreenByTinglyGames"] = "제작: CoolGames";
dictionaryVar["ko-kr"]["optionsLang_de-de"] = "독일어";
dictionaryVar["ko-kr"]["optionsLang_tr-tr"] = "터키어";
dictionaryVar["ko-kr"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["ko-kr"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["ko-kr"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["ko-kr"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["ko-kr"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["ko-kr"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["ko-kr"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["ko-kr"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["ko-kr"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["ko-kr"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["ko-kr"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["ko-kr"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["ko-kr"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["ko-kr"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["ko-kr"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["ko-kr"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["ko-kr"]["challengeEndScreenName_you"] = "You";
dictionaryVar["ko-kr"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["ko-kr"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["ko-kr"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["ko-kr"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["ko-kr"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["ko-kr"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["ko-kr"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["ko-kr"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["ko-kr"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["ko-kr"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["ko-kr"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["ko-kr"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["ko-kr"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["ko-kr"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["ko-kr"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["ko-kr"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["ko-kr"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["ko-kr"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["ko-kr"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["ko-kr"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["ko-kr"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["ko-kr"]["optionsLang_fr-fr"] = "프랑스어";
dictionaryVar["ko-kr"]["optionsLang_ko-kr"] = "한국어";
dictionaryVar["ko-kr"]["optionsLang_ar-eg"] = "아라비아어";
dictionaryVar["ko-kr"]["optionsLang_es-es"] = "스페인어";
dictionaryVar["ko-kr"]["optionsLang_pt-br"] = "포르투갈어(브라질)";
dictionaryVar["ko-kr"]["optionsLang_ru-ru"] = "러시아어";
dictionaryVar["ko-kr"]["optionsExit"] = "Exit";
dictionaryVar["ko-kr"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["ko-kr"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["ko-kr"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["ko-kr"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["ko-kr"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["ko-kr"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["ko-kr"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["ko-kr"]["optionsLang_it-it"] = "Italian";
dictionaryVar["it-it"] = dictionaryVar["it-it"] || {};
dictionaryVar["it-it"]["loadingScreenLoading"] = "Caricamento...";
dictionaryVar["it-it"]["startScreenPlay"] = "GIOCA";
dictionaryVar["it-it"]["levelMapScreenTotalScore"] = "Punteggio totale";
dictionaryVar["it-it"]["levelEndScreenTitle_level"] = "Livello <VALUE>";
dictionaryVar["it-it"]["levelEndScreenTitle_difficulty"] = "Ottimo lavoro!";
dictionaryVar["it-it"]["levelEndScreenTitle_endless"] = "Livello <VALUE>";
dictionaryVar["it-it"]["levelEndScreenTotalScore"] = "Punteggio totale";
dictionaryVar["it-it"]["levelEndScreenSubTitle_levelFailed"] = "Non hai superato il livello";
dictionaryVar["it-it"]["levelEndScreenTimeLeft"] = "Tempo rimanente";
dictionaryVar["it-it"]["levelEndScreenTimeBonus"] = "Tempo bonus";
dictionaryVar["it-it"]["levelEndScreenHighScore"] = "Record";
dictionaryVar["it-it"]["optionsStartScreen"] = "Menu principale";
dictionaryVar["it-it"]["optionsQuit"] = "Esci";
dictionaryVar["it-it"]["optionsResume"] = "Riprendi";
dictionaryVar["it-it"]["optionsTutorial"] = "Come si gioca";
dictionaryVar["it-it"]["optionsHighScore"] = "Record";
dictionaryVar["it-it"]["optionsMoreGames"] = "Altri giochi";
dictionaryVar["it-it"]["optionsDifficulty_easy"] = "Facile";
dictionaryVar["it-it"]["optionsDifficulty_medium"] = "Media";
dictionaryVar["it-it"]["optionsDifficulty_hard"] = "Difficile";
dictionaryVar["it-it"]["optionsMusic_on"] = "Sì";
dictionaryVar["it-it"]["optionsMusic_off"] = "No";
dictionaryVar["it-it"]["optionsSFX_on"] = "Sì";
dictionaryVar["it-it"]["optionsSFX_off"] = "No";
dictionaryVar["it-it"]["optionsLang_en-us"] = "Inglese (US)";
dictionaryVar["it-it"]["optionsLang_en-gb"] = "Inglese (UK)";
dictionaryVar["it-it"]["optionsLang_nl-nl"] = "Olandese";
dictionaryVar["it-it"]["gameEndScreenTitle"] = "Congratulazioni!\nHai completato il gioco.";
dictionaryVar["it-it"]["gameEndScreenBtnText"] = "Continua";
dictionaryVar["it-it"]["optionsTitle"] = "Impostazioni";
dictionaryVar["it-it"]["optionsQuitConfirmationText"] = "Attenzione!\n\nSe abbandoni ora, perderai tutti i progressi ottenuti in questo livello. Confermi?";
dictionaryVar["it-it"]["optionsQuitConfirmBtn_No"] = "No";
dictionaryVar["it-it"]["optionsQuitConfirmBtn_Yes"] = "Sì, ho deciso";
dictionaryVar["it-it"]["levelMapScreenTitle"] = "Scegli un livello";
dictionaryVar["it-it"]["optionsRestartConfirmationText"] = "Attenzione!\n\nSe riavvii ora, perderai tutti i progressi ottenuti in questo livello. Confermi?";
dictionaryVar["it-it"]["optionsRestart"] = "Riavvia";
dictionaryVar["it-it"]["optionsSFXBig_on"] = "Audio SÌ";
dictionaryVar["it-it"]["optionsSFXBig_off"] = "Audio NO";
dictionaryVar["it-it"]["optionsAbout_title"] = "Informazioni";
dictionaryVar["it-it"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["it-it"]["optionsAbout_backBtn"] = "Indietro";
dictionaryVar["it-it"]["optionsAbout_version"] = "versione:";
dictionaryVar["it-it"]["optionsAbout"] = "Informazioni";
dictionaryVar["it-it"]["levelEndScreenMedal"] = "MIGLIORATO!";
dictionaryVar["it-it"]["startScreenQuestionaire"] = "Che ne pensi?";
dictionaryVar["it-it"]["levelMapScreenWorld_0"] = "Scegli un livello";
dictionaryVar["it-it"]["startScreenByTinglyGames"] = "di: CoolGames";
dictionaryVar["it-it"]["optionsLang_de-de"] = "Tedesco";
dictionaryVar["it-it"]["optionsLang_tr-tr"] = "Turco";
dictionaryVar["it-it"]["optionsAbout_header"] = "Sviluppato da:";
dictionaryVar["it-it"]["levelEndScreenViewHighscoreBtn"] = "Guarda i punteggi";
dictionaryVar["it-it"]["levelEndScreenSubmitHighscoreBtn"] = "Invia il punteggio";
dictionaryVar["it-it"]["challengeStartScreenTitle_challengee_friend"] = "Hai ricevuto una sfida da:";
dictionaryVar["it-it"]["challengeStartTextScore"] = "punteggio di <NAME>:";
dictionaryVar["it-it"]["challengeStartTextTime"] = "tempo di <NAME>:";
dictionaryVar["it-it"]["challengeStartScreenToWin"] = "Necessario per vincere:";
dictionaryVar["it-it"]["challengeEndScreenWinnings"] = "Hai vinto <AMOUNT> fairpoint";
dictionaryVar["it-it"]["challengeEndScreenOutcomeMessage_WON"] = "Hai vinto la sfida!";
dictionaryVar["it-it"]["challengeEndScreenOutcomeMessage_LOST"] = "Hai perso la sfida.";
dictionaryVar["it-it"]["challengeEndScreenOutcomeMessage_TIED"] = "Hai pareggiato.";
dictionaryVar["it-it"]["challengeCancelConfirmText"] = "Stai per annullare la sfida. Recupererai la posta, tranne la quota di partecipazione alla sfida. Confermi?";
dictionaryVar["it-it"]["challengeCancelConfirmBtn_yes"] = "Sì";
dictionaryVar["it-it"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["it-it"]["challengeEndScreensBtn_submit"] = "Invia la sfida";
dictionaryVar["it-it"]["challengeEndScreenBtn_cancel"] = "Annulla la sfida";
dictionaryVar["it-it"]["challengeEndScreenName_you"] = "Tu";
dictionaryVar["it-it"]["challengeEndScreenChallengeSend_error"] = "Impossibile inviare la sfida. Riprova più tardi.";
dictionaryVar["it-it"]["challengeEndScreenChallengeSend_success"] = "Sfida inviata!";
dictionaryVar["it-it"]["challengeCancelMessage_error"] = "Impossibile annullare la sfida. Riprova più tardi.";
dictionaryVar["it-it"]["challengeCancelMessage_success"] = "Sfida annullata.";
dictionaryVar["it-it"]["challengeEndScreenScoreSend_error"] = "Impossibile comunicare col server. Riprova più tardi.";
dictionaryVar["it-it"]["challengeStartScreenTitle_challengee_stranger"] = "Sei stato abbinato a:";
dictionaryVar["it-it"]["challengeStartScreenTitle_challenger_friend"] = "Stai sfidando:";
dictionaryVar["it-it"]["challengeStartScreenTitle_challenger_stranger"] = "Stai impostando un punteggio da battere per:";
dictionaryVar["it-it"]["challengeStartTextTime_challenger"] = "Gioca e imposta un tempo da battere.";
dictionaryVar["it-it"]["challengeStartTextScore_challenger"] = "Gioca e imposta un punteggio da superare.";
dictionaryVar["it-it"]["challengeForfeitConfirmText"] = "Stai per abbandonare la sfida. Confermi?";
dictionaryVar["it-it"]["challengeForfeitConfirmBtn_yes"] = "Sì";
dictionaryVar["it-it"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["it-it"]["challengeForfeitMessage_success"] = "Hai abbandonato la sfida.";
dictionaryVar["it-it"]["challengeForfeitMessage_error"] = "Impossibile abbandonare la sfida. Riprova più tardi.";
dictionaryVar["it-it"]["optionsChallengeForfeit"] = "Abbandona";
dictionaryVar["it-it"]["optionsChallengeCancel"] = "Esci";
dictionaryVar["it-it"]["challengeLoadingError_notValid"] = "La sfida non è più valida.";
dictionaryVar["it-it"]["challengeLoadingError_notStarted"] = "Impossibile connettersi al server. Riprova più tardi.";
dictionaryVar["it-it"]["levelEndScreenHighScore_time"] = "Miglior tempo:";
dictionaryVar["it-it"]["levelEndScreenTotalScore_time"] = "Tempo totale:";
dictionaryVar["it-it"]["optionsLang_fr-fr"] = "Francese";
dictionaryVar["it-it"]["optionsLang_ko-kr"] = "Coreano";
dictionaryVar["it-it"]["optionsLang_ar-eg"] = "Arabo";
dictionaryVar["it-it"]["optionsLang_es-es"] = "Spagnolo";
dictionaryVar["it-it"]["optionsLang_pt-br"] = "Brasiliano - Portoghese";
dictionaryVar["it-it"]["optionsLang_ru-ru"] = "Russo";
dictionaryVar["it-it"]["optionsExit"] = "Esci";
dictionaryVar["it-it"]["levelEndScreenTotalScore_number"] = "Punteggio totale:";
dictionaryVar["it-it"]["levelEndScreenHighScore_number"] = "Record:";
dictionaryVar["it-it"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> ha a disposizione 72 ore per accettare o rifiutare la tua sfida. Se la rifiuta, o non la accetta entro 72 ore, recupererai la posta e la quota di partecipazione alla sfida.";
dictionaryVar["it-it"]["challengeEndScreenChallengeSend_submessage_stranger"] = "Se nessuno accetta la tua sfida entro 72 ore, recuperi la posta e la quota di partecipazione alla sfida.";
dictionaryVar["it-it"]["challengeForfeitMessage_winnings"] = "<NAME> ha vinto <AMOUNT> fairpoint!";
dictionaryVar["it-it"]["optionsAbout_header_publisher"] = "Distribuito da:";
dictionaryVar["it-it"]["optionsLang_jp-jp"] = "Giapponese";
dictionaryVar["it-it"]["optionsLang_it-it"] = "Italiano";
dictionaryVar["pl-pl"] = dictionaryVar["pl-pl"] || {};
dictionaryVar["pl-pl"]["loadingScreenLoading"] = "Loading...";
dictionaryVar["pl-pl"]["startScreenPlay"] = "PLAY";
dictionaryVar["pl-pl"]["levelMapScreenTotalScore"] = "Total score";
dictionaryVar["pl-pl"]["levelEndScreenTitle_level"] = "Level <VALUE>";
dictionaryVar["pl-pl"]["levelEndScreenTitle_difficulty"] = "Well done!";
dictionaryVar["pl-pl"]["levelEndScreenTitle_endless"] = "Stage <VALUE>";
dictionaryVar["pl-pl"]["levelEndScreenTotalScore"] = "Total score";
dictionaryVar["pl-pl"]["levelEndScreenSubTitle_levelFailed"] = "Level failed";
dictionaryVar["pl-pl"]["levelEndScreenTimeLeft"] = "Time remaining";
dictionaryVar["pl-pl"]["levelEndScreenTimeBonus"] = "Time bonus";
dictionaryVar["pl-pl"]["levelEndScreenHighScore"] = "High score";
dictionaryVar["pl-pl"]["optionsStartScreen"] = "Main menu";
dictionaryVar["pl-pl"]["optionsQuit"] = "Quit";
dictionaryVar["pl-pl"]["optionsResume"] = "Resume";
dictionaryVar["pl-pl"]["optionsTutorial"] = "How to play";
dictionaryVar["pl-pl"]["optionsHighScore"] = "High scores";
dictionaryVar["pl-pl"]["optionsMoreGames"] = "More Games";
dictionaryVar["pl-pl"]["optionsDifficulty_easy"] = "Easy";
dictionaryVar["pl-pl"]["optionsDifficulty_medium"] = "Medium";
dictionaryVar["pl-pl"]["optionsDifficulty_hard"] = "Difficult";
dictionaryVar["pl-pl"]["optionsMusic_on"] = "On";
dictionaryVar["pl-pl"]["optionsMusic_off"] = "Off";
dictionaryVar["pl-pl"]["optionsSFX_on"] = "On";
dictionaryVar["pl-pl"]["optionsSFX_off"] = "Off";
dictionaryVar["pl-pl"]["optionsLang_en-us"] = "English (US)";
dictionaryVar["pl-pl"]["optionsLang_en-gb"] = "English (GB)";
dictionaryVar["pl-pl"]["optionsLang_nl-nl"] = "Dutch";
dictionaryVar["pl-pl"]["gameEndScreenTitle"] = "Congratulations!\nYou have completed the game.";
dictionaryVar["pl-pl"]["gameEndScreenBtnText"] = "Continue";
dictionaryVar["pl-pl"]["optionsTitle"] = "Settings";
dictionaryVar["pl-pl"]["optionsQuitConfirmationText"] = "Attention!\n\nIf you quit now you will lose all progress made during this level. Are you sure you want to quit?";
dictionaryVar["pl-pl"]["optionsQuitConfirmBtn_No"] = "No";
dictionaryVar["pl-pl"]["optionsQuitConfirmBtn_Yes"] = "Yes, I'm sure";
dictionaryVar["pl-pl"]["levelMapScreenTitle"] = "Select a level";
dictionaryVar["pl-pl"]["optionsRestartConfirmationText"] = "Attention!\n\nIf you restart now you will lose all progress made during this level. Are you sure you want to restart?";
dictionaryVar["pl-pl"]["optionsRestart"] = "Restart";
dictionaryVar["pl-pl"]["optionsSFXBig_on"] = "Sound on";
dictionaryVar["pl-pl"]["optionsSFXBig_off"] = "Sound off";
dictionaryVar["pl-pl"]["optionsAbout_title"] = "About";
dictionaryVar["pl-pl"]["optionsAbout_text"] = "CoolGames\nwww.coolgames.com\n© 2017";
dictionaryVar["pl-pl"]["optionsAbout_backBtn"] = "Back";
dictionaryVar["pl-pl"]["optionsAbout_version"] = "version:";
dictionaryVar["pl-pl"]["optionsAbout"] = "About";
dictionaryVar["pl-pl"]["levelEndScreenMedal"] = "IMPROVED!";
dictionaryVar["pl-pl"]["startScreenQuestionaire"] = "What do you think?";
dictionaryVar["pl-pl"]["levelMapScreenWorld_0"] = "Select a level";
dictionaryVar["pl-pl"]["startScreenByTinglyGames"] = "by: CoolGames";
dictionaryVar["pl-pl"]["optionsLang_de-de"] = "German";
dictionaryVar["pl-pl"]["optionsLang_tr-tr"] = "Turkish";
dictionaryVar["pl-pl"]["optionsAbout_header"] = "Developed by:";
dictionaryVar["pl-pl"]["levelEndScreenViewHighscoreBtn"] = "View scores";
dictionaryVar["pl-pl"]["levelEndScreenSubmitHighscoreBtn"] = "Submit score";
dictionaryVar["pl-pl"]["challengeStartScreenTitle_challengee_friend"] = "You have been challenged by:";
dictionaryVar["pl-pl"]["challengeStartTextScore"] = "<NAME>'s score:";
dictionaryVar["pl-pl"]["challengeStartTextTime"] = "<NAME>'s time:";
dictionaryVar["pl-pl"]["challengeStartScreenToWin"] = "Amount to win:";
dictionaryVar["pl-pl"]["challengeEndScreenWinnings"] = "You have won <AMOUNT> fairpoints";
dictionaryVar["pl-pl"]["challengeEndScreenOutcomeMessage_WON"] = "You have won the challenge!";
dictionaryVar["pl-pl"]["challengeEndScreenOutcomeMessage_LOST"] = "You have lost the challenge.";
dictionaryVar["pl-pl"]["challengeEndScreenOutcomeMessage_TIED"] = "You tied.";
dictionaryVar["pl-pl"]["challengeCancelConfirmText"] = "You are about to cancel the challenge. Your wager will be returned minus the challenge fee. Are you sure you want to cancel the challenge?";
dictionaryVar["pl-pl"]["challengeCancelConfirmBtn_yes"] = "Yes";
dictionaryVar["pl-pl"]["challengeCancelConfirmBtn_no"] = "No";
dictionaryVar["pl-pl"]["challengeEndScreensBtn_submit"] = "Submit challenge";
dictionaryVar["pl-pl"]["challengeEndScreenBtn_cancel"] = "Cancel challenge";
dictionaryVar["pl-pl"]["challengeEndScreenName_you"] = "You";
dictionaryVar["pl-pl"]["challengeEndScreenChallengeSend_error"] = "An error occured while submitting the challenge. Please try again later.";
dictionaryVar["pl-pl"]["challengeEndScreenChallengeSend_success"] = "Your challenge has been sent!";
dictionaryVar["pl-pl"]["challengeCancelMessage_error"] = "An error occured while cancelling your challenge. Please try again later.";
dictionaryVar["pl-pl"]["challengeCancelMessage_success"] = "Your challenge has been cancelled.";
dictionaryVar["pl-pl"]["challengeEndScreenScoreSend_error"] = "An error occured while communicating with the server. Please try again later.";
dictionaryVar["pl-pl"]["challengeStartScreenTitle_challengee_stranger"] = "You have been matched with:";
dictionaryVar["pl-pl"]["challengeStartScreenTitle_challenger_friend"] = "You are challenging:";
dictionaryVar["pl-pl"]["challengeStartScreenTitle_challenger_stranger"] = "You are setting a score for:";
dictionaryVar["pl-pl"]["challengeStartTextTime_challenger"] = "Play the game and set a time.";
dictionaryVar["pl-pl"]["challengeStartTextScore_challenger"] = "Play the game and set a score.";
dictionaryVar["pl-pl"]["challengeForfeitConfirmText"] = "You are about to forfeit the challenge. Are you sure you want to proceed?";
dictionaryVar["pl-pl"]["challengeForfeitConfirmBtn_yes"] = "Yes";
dictionaryVar["pl-pl"]["challengeForfeitConfirmBtn_no"] = "No";
dictionaryVar["pl-pl"]["challengeForfeitMessage_success"] = "You have forfeited the challenge.";
dictionaryVar["pl-pl"]["challengeForfeitMessage_error"] = "An error occured while forfeiting the challenge. Please try again later.";
dictionaryVar["pl-pl"]["optionsChallengeForfeit"] = "Forfeit";
dictionaryVar["pl-pl"]["optionsChallengeCancel"] = "Quit";
dictionaryVar["pl-pl"]["challengeLoadingError_notValid"] = "Sorry, this challenge is no longer valid.";
dictionaryVar["pl-pl"]["challengeLoadingError_notStarted"] = "Unable to connect to the server. Please try again later.";
dictionaryVar["pl-pl"]["levelEndScreenHighScore_time"] = "Best time:";
dictionaryVar["pl-pl"]["levelEndScreenTotalScore_time"] = "Total time:";
dictionaryVar["pl-pl"]["optionsLang_fr-fr"] = "French";
dictionaryVar["pl-pl"]["optionsLang_ko-kr"] = "Korean";
dictionaryVar["pl-pl"]["optionsLang_ar-eg"] = "Arabic";
dictionaryVar["pl-pl"]["optionsLang_es-es"] = "Spanish";
dictionaryVar["pl-pl"]["optionsLang_pt-br"] = "Brazilian-Portuguese";
dictionaryVar["pl-pl"]["optionsLang_ru-ru"] = "Russian";
dictionaryVar["pl-pl"]["optionsExit"] = "Exit";
dictionaryVar["pl-pl"]["levelEndScreenTotalScore_number"] = "Total score:";
dictionaryVar["pl-pl"]["levelEndScreenHighScore_number"] = "High score:";
dictionaryVar["pl-pl"]["challengeEndScreenChallengeSend_submessage"] = "<NAME> has 72 hours to accept or decline your challenge. If <NAME> declines or doesn’t accept within 72 hours your wager and challenge fee will be reimbursed.";
dictionaryVar["pl-pl"]["challengeEndScreenChallengeSend_submessage_stranger"] = "If no one accepts your challenge within 72 hours, the amount of your wager and the challenge fee will be returned to you.";
dictionaryVar["pl-pl"]["challengeForfeitMessage_winnings"] = "<NAME> has won <AMOUNT> fairpoints!";
dictionaryVar["pl-pl"]["optionsAbout_header_publisher"] = "Published by:";
dictionaryVar["pl-pl"]["optionsLang_jp-jp"] = "Japanese";
dictionaryVar["pl-pl"]["optionsLang_it-it"] = "Italian";
